import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Row, Card, Spinner, Modal, Form, Pagination } from 'react-bootstrap';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CouponsList = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [couponAccess, setCouponAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Coupons:")
            );
            setCouponAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", couponAccess);

    const accessToken = localStorage.getItem('authToken');
    const animatedComponents = makeAnimated();
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(50);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [activeTab, setActiveTab] = useState("ACTIVE");
    const [searchActiveData, setSearchActiveData] = useState([]);
    const [searchInactiveData, setSearchInactiveData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedFilter, setSelectedFilter] = useState("ALL");
    const [couponsData, setCouponsData] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [couponId, setCouponId] = useState('');
    const [openViewModal, setOpenViewModal] = useState(false);
    const [singleCouponDetails, setSingleCouponDetails] = useState({});
    const [isSearchBtnLoading, setIsSearchBtnLoading] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [couponData, setCouponData] = useState({});
    const [editData, setEditData] = useState({});
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const [selections, setSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedApplicableCategories: [],
        selectedApplicableProducts: [],
        selectedAddons: [],
        selectedAddonValues: [],
        selectedDependentCategories: [],
        selectedDependentProducts: [],
        selectedExcludedProducts: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: []
    });
    const [sizeCouponProducts, setSizeCouponProducts] = useState({
        applicableProducts: []
    })
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [exProductList, setExProductList] = useState([]);
    const [currentTerm, setCurrentTerm] = useState('');
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [addonList, setAddonList] = useState([]);
    const [levels, setLevels] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [addonValueList, setAddonValueList] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [productAddonsList, setProductAddonsList] = useState([]);
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [selectedIncludedOutlets, setSelectedIncludedOutlets] = useState([]);
    const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
    const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
    const [allAddonList, setAllAddonList] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const navigate = useNavigate();

    const maxWords = 6; // Adjust the max words as needed

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
    };

    const outletData = outlets
        .filter(
            (outlet) =>
                !selectedExcludedOutlets.some((selected) => selected.value === outlet._id) && // Exclude selected Excluded outlets
                !selectedIncludedOutlets.some((selected) => selected.value === outlet._id) // Exclude selected Included outlets
        )
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    const categoriesList = categoriesData.map((category) => ({
        value: category._id,
        label: `${category.name}`
    }));

    const productsInfo = productsList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const exProductInfo = exProductList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    // Freebie Products List - only products with isFreebieProduct = true
    const freebieProductsOptions = productsList
        .filter(product => product.isFreebieProduct === true)
        .map((product) => ({
            value: product?._id,
            label: `${product?.name}`
        }))

    const addonProductsInfo = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    const exAddonProductInfo = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name
    }))

    const addonsInfo = productAddonsList?.map((add) => ({
        value: add?._id,
        label: <span>
            {add?.addonTitle} <span className=''>{" -> "}</span> <span style={{ color: "grey" }}> {add?.product?.name}</span>
        </span>
    }))

    const addonsValueInfo = addonValueList?.flatMap((addon) =>
        addon?.originalAddonValues?.map((original) => ({
            adTitleId: addon._id,
            value: original?._id, // Assuming originalAddonValues have an _id property
            label: (
                <span>
                    {original?.value || "No Name"}{" "}
                    <span className="">{" -> "}</span> <span style={{ color: "grey" }}> {addon?.addonTitle}</span> <span className="">{" >> "}</span> <span style={{ color: "grey" }}> {addon?.product?.name}</span>
                </span>
            ),
        }))
    );

    const levelsData = levels.map((level) => ({
        value: level._id,
        label: `${level.sequenceNo}. ${level.title}`
    }));

    // Fetches the category list from the server and updates state. 
    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoriesData(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    // Fetches the products list from the server and updates state.
    const getProductsList = async (catId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products);
                let excludedProducts = [];
                if (catId) {
                    excludedProducts = response?.data?.data?.products?.filter((fi) =>
                        catId.some((category) => category.value === fi?.category?._id)
                    );
                    // setExProductList(excludedProducts);
                    setExProductList(response?.data?.data?.products)

                } else {
                    setExProductList(response?.data?.data?.products)
                }
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getAllCouponsData = async (page, limit, status, search) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // let endPoint
            let endpoint = `coupons?page=${page}&limit=${limit}&isCouponAllocated=false&status=${status}`;

            if (search) {
                endpoint += `&search=${search}`
            }

            const response = await axios.get(endpoint, { headers });

            if (response?.data?.status === true) {
                setCouponsData(response?.data?.data?.coupons);
                setTotalPages(response?.data?.data?.pagination?.totalPages);
                setTotalRecords(response?.data?.data?.pagination?.totalRecords || 0);
            }
        } catch (error) {
            console.log("Error :", error);

            if (error.response?.data?.status === false) {
                let errorMessage = error.response?.data?.data?.message || "Resource not found";
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const getSingleCouponDetails = async (couponId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`coupons?_id=${couponId}`, { headers });

            if (response?.data?.status === true) {
                console.log("Single Coupons Information :", response?.data?.data?.coupons);

                setSingleCouponDetails(response?.data?.data?.coupons);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getAddonProductsList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product-addon?limit=1000&page=1", { headers });
            if (response?.data?.status === true) {
                const addOns = response?.data?.data?.productAddons
                // const sizeAddons = addOns.filter((item) => item?.addonTitle === "Size");
                const productsWithSizeAddon = addOns.filter((item) =>
                    item.addons.some((addon) => addon.addonTitle.toLowerCase() === 'size')
                );
                setAddonList(productsWithSizeAddon)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getCategoryProductAddons = async (categ, prod, addIds) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let categories = categ?.map((opt) => opt?.value);
            let products = prod?.map((opt) => opt?.value);

            console.log("Categories :", categories);
            console.log("Products :", products);

            // Construct the payload with arrays
            const payload = {
                applicableCategories: categories,
                applicableProducts: products,
            };

            if (payload?.applicableCategories?.length === 0) {
                delete payload?.applicableCategories
            }

            if (payload?.applicableProducts?.length === 0) {
                delete payload?.applicableProducts
            }

            console.log("Payload to send:", payload);

            const response = await axios.post("/coupons/get-dependant-product-category-addons", payload, { headers });
            setProductAddonsList(response?.data?.data?.addons);
            let filteredAddonValues = response?.data?.data?.addons?.filter((val) =>
                addIds?.includes(val?._id) // Check if val._id exists in addIds
            );
            setAddonValueList(filteredAddonValues);
        } catch (error) {
            console.log("Error :", error);
        }
    };

    const getAddonList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("addons?page=1&limit=100", { headers });
            console.log("Response of all addons :", response?.data?.data);

            if (response?.data?.status === true) {
                console.log("Response of all addons :", response?.data?.data?.addons);
                setAllAddonList(response?.data?.data?.addons);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    // Fetches the outlet list from the server and updates state.
    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getLevels = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("level", { headers });
            if (response?.data?.status === true) {
                const levels = response?.data?.data?.levels;
                setLevels(levels)
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        getAllCouponsData(currentPage, recordsPerPage, tab, searchText); // Fetch data for the new tab
    };

    const activeCoupons = couponsData
        .filter((coupon) => {
            // 1️⃣ Explicitly exclude inactive coupons
            if (coupon?.status === "INACTIVE") {
                return false;
            }

            // 2️⃣ Active coupon with no validity dates → active
            if (
                coupon?.status === "ACTIVE" &&
                !coupon.validityStartDate &&
                !coupon.validityEndDate
            ) {
                return true;
            }

            // 3️⃣ Active coupon with end date → check expiry
            if (coupon?.status === "ACTIVE" && coupon.validityEndDate) {
                return new Date(coupon.validityEndDate) >= new Date();
            }

            return false;
        })
        .sort((a, b) => {
            if (!a.validityEndDate && !b.validityEndDate) return 0;
            if (!a.validityEndDate) return -1;
            if (!b.validityEndDate) return 1;
            return new Date(a.validityEndDate) - new Date(b.validityEndDate);
        });

    const inactiveCoupons = couponsData
        .filter((coupon) => {
            // 1️⃣ Explicitly include inactive coupons
            if (coupon?.status === "INACTIVE") {
                return true;
            }

            // 2️⃣ Exclude active coupons with no validity dates
            if (
                coupon?.status === "ACTIVE" &&
                !coupon.validityStartDate &&
                !coupon.validityEndDate
            ) {
                return false;
            }

            // 3️⃣ If expiry date exists, check if expired
            if (coupon.validityEndDate) {
                return new Date(coupon.validityEndDate) < new Date();
            }

            return false;
        })
        .sort((a, b) => {
            if (!a.validityEndDate && !b.validityEndDate) return 0;
            if (!a.validityEndDate) return -1;
            if (!b.validityEndDate) return 1;
            return new Date(a.validityEndDate) - new Date(b.validityEndDate);
        });

    const convertDate = (dateString) => {
        if (!dateString) {
            return "Invalid Date";
        }

        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const dateParts = dateString.split("-");
        if (dateParts.length !== 3) {
            return "Invalid Date";
        }

        const year = dateParts[0];
        const month = parseInt(dateParts[1], 10) - 1;
        const day = dateParts[2];

        if (isNaN(month) || isNaN(day) || isNaN(year)) {
            return "Invalid Date";
        }

        const formattedDate = `${day} ${months[month]} ${year}`;

        return formattedDate;
    }

    //Sets All Addon Titles
    const handleSelectAllAddonChange = (fieldName, selectedOptions) => {
        console.log("Field name:", fieldName, "selectedOptions:", selectedOptions);

        let selectedItems = [];
        let addonValuesOptions = [];

        if (fieldName === 'excludedAddonGroups') {
            // Update selected addon groups
            setSelectedAddonGroups(selectedOptions || []);

            // ✅ If no addons selected, clear values and reset form data
            if (!selectedOptions || selectedOptions.length === 0) {
                setFilteredAddonValues([]);
                setCouponData(prev => ({
                    ...prev,
                    [fieldName]: [],
                    excludedAddonValues: [] // clear dependent addon values
                }));
                return;
            }

            // ✅ Generate addon value options only for selected addons
            addonValuesOptions = selectedOptions.flatMap(option => {
                const addon = allAddonList?.find(a => a?._id === option?.value);
                if (!addon) return [];

                return addon?.addonValues?.map(val => ({
                    value: {
                        addonId: addon._id,
                        addValueId: val._id,
                        addonTitle: addon.title,
                        addonValueTitle: val.value
                    },
                    label: `${addon.title} - ${val.value}`
                })) || [];
            });

            // ✅ Store the selected addon groups (for couponData)
            selectedItems = allAddonList.filter(addon =>
                selectedOptions.some(option => option.value === addon._id)
            );

            // ✅ Update filtered values list
            setFilteredAddonValues(addonValuesOptions);

            // ✅ Remove excludedAddonValues that no longer belong to selected groups
            setCouponData(prev => {
                const filteredExcludedValues = (prev.excludedAddonValues || []).filter(val =>
                    selectedOptions.some(opt => opt.value === val.addonId)
                );

                return {
                    ...prev,
                    [fieldName]: selectedItems,
                    excludedAddonValues: filteredExcludedValues
                };
            });

            return; // end here to avoid duplicate setCouponData below
        }

        // Default update for other fields (if needed)
        setCouponData(prev => ({
            ...prev,
            [fieldName]: selectedItems
        }));
    };

    const updatedDate = (date) => {
        const formattedDate = date?.split("T")[0];
        return formattedDate;
    };

    const handleOpenViewModal = (data) => {
        getSingleCouponDetails(data?._id);
        setOpenViewModal(true);
    };

    // CLOSE THE EDIT MODAL
    const handleCloseEditModal = () => {
        setOpenEditModal(false)
    };

    const handleEditFormInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "dayOfWeek" && (value === "null" || value === null)) {
            setEditData((prev) => ({ ...prev, [name]: null }))
        } else {
            setEditData((prev) => ({ ...prev, [name]: value }))
        }
    };

    const addTerm = () => {
        if (!currentTerm.trim()) return;

        setEditData((prevData) => ({
            ...prevData,
            termsAndConditions: [...(prevData?.termsAndConditions || []), currentTerm],
        }));

        setCurrentTerm(''); // Clear input after adding
    };

    const removeTerm = (index) => {
        setEditData((prevData) => ({
            ...prevData,
            termsAndConditions: (prevData?.termsAndConditions || []).filter(
                (_, i) => i !== index
            ),
        }));
    };

    // New Size Addons Api 
    const getNewSizeAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
            console.log("Response of new size addons :", response?.data?.data);
            setNewSizeAddonsList(response?.data?.data?.addons);
            let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []);
            setNewProductsFromAddons(newproducts);
        } catch (error) {
            console.log("Error :", error);
        }
    }

    const handleOpenEditModal = (data) => {
        setOpenEditModal(true);
        console.log("Edit Data :", data);

        // Format start and end dates
        const formattedStartDate = data?.validityStartDate
            ? new Date(data.validityStartDate).toISOString().split("T")[0]
            : null;
        const formattedEndDate = data?.validityEndDate
            ? new Date(data.validityEndDate).toISOString().split("T")[0]
            : null;

        // -----------------------------
        // Determine Coupon Type
        // -----------------------------
        if (data?.isFreebieCoupon) {
            setSelectedCheckbox('isFreebieCoupon');
        } else if (((data?.primaryComboCategories?.length > 0 || data?.secondaryComboCategories?.length > 0) && (data?.excludedProducts?.length > 0 || data?.isComboCategoryCoupon))) {
            setSelectedCheckbox('isComboCoupon');
        } else if (data?.isBogoCoupon || (data?.isBogoCoupon && data?.excludedProducts?.length > 0)) {
            setSelectedCheckbox('isBogoCoupon');
        } else if ((data?.discountPercent !== null && data?.minOrderAmount === null && data?.applicableProducts?.length === 0 && data?.applicableCategories?.length === 0) || (data?.discountPercent !== null && data?.minOrderAmount === null && data?.excludedProducts?.length > 0 && data?.applicableCategories?.length === 0)) {
            setSelectedCheckbox('isUniversalCoupon');
        } else if ((data?.discountPercent !== null && data?.minOrderAmount !== null) || (data?.minOrderAmount !== null && data?.discountAmount !== null && data?.applicableCategories?.length === 0) || (data?.discountPercent !== null && data?.minOrderAmount !== null && data?.excludedProducts?.length > 0) || (data?.discountAmount !== null && data?.minOrderAmount !== null && data?.excludedProducts?.length > 0)) {
            setSelectedCheckbox('isCartCoupon');
        } else if ((data?.sizeUpgradeAddon || data?.newSizeUpgradeAddon) && !data?.isBogoCoupon) {
            setSelectedCheckbox('isSizeUpgradeCoupon');
        } else if ((data?.applicableProducts?.length > 0 && data?.discountPrice == null) && data?.applicableCategories?.length === 0) {
            setSelectedCheckbox('isProductCoupon');
        } else if ((data?.applicableCategories?.length > 0 && data?.discountPrice == null) && data?.applicableProducts?.length === 0) {
            setSelectedCheckbox('isCategoryCoupon');
        } else if (data?.discountPrice && data?.applicableQuantityType) {
            if (data?.applicableCategories?.length > 0 || (data?.applicableCategories?.length > 0 && data?.minOrderAmount !== null && data?.discountPrice)) {
                setSelectedCheckbox('isSpecialCategoryCoupon');
            } else {
                setSelectedCheckbox('isSpecialProductCoupon');
            }
        }

        // -----------------------------
        // Format React Select values
        // -----------------------------
        const formattedSelections = {};

        // Combo categories
        if (data?.primaryComboCategories?.length) {
            formattedSelections.primaryComboCategories = data.primaryComboCategories.map(cat => ({
                value: cat._id,
                label: cat.name,
            }));
        }
        if (data?.secondaryComboCategories?.length) {
            formattedSelections.secondaryComboCategories = data.secondaryComboCategories.map(cat => ({
                value: cat._id,
                label: cat.name,
            }));
        }

        // Included / Excluded outlets
        if (data?.includedOutlets?.length) {
            formattedSelections.selectedIncludedOutlets = data.includedOutlets.map(o => ({
                value: o._id,
                label: o.name,
            }));
        }
        if (data?.excludedOutlets?.length) {
            formattedSelections.selectedExcludedOutlets = data.excludedOutlets.map(o => ({
                value: o._id,
                label: o.name,
            }));
        }

        // Applicable categories / products
        if (data?.applicableCategories?.length) {
            formattedSelections.selectedApplicableCategories = data.applicableCategories.map(cat => ({
                value: cat._id,
                label: cat.name,
            }));
            getProductsList(data.applicableCategories.map(cat => ({ value: cat._id, label: cat.name })));
        }
        if (data?.applicableProducts?.length) {
            formattedSelections.selectedApplicableProducts = data.applicableProducts.map(prod => ({
                value: prod._id,
                label: prod.name,
            }));
        }

        // Dependent categories / products
        if (data?.dependantCategories?.length) {
            formattedSelections.selectedDependentCategories = data.dependantCategories.map(cat => ({
                value: cat._id,
                label: cat.name,
            }));
        }
        if (data?.dependantProducts?.length) {
            formattedSelections.selectedDependentProducts = data.dependantProducts.map(prod => ({
                value: prod._id,
                label: prod.name,
            }));
        }

        // Excluded products
        if (data?.manuallyExcludedProducts?.length) {
            formattedSelections.selectedExcludedProducts = data.manuallyExcludedProducts.map(prod => ({
                value: prod._id,
                label: prod.name,
            }));
        }

        // Excluded products
        if (data?.excludedProducts?.length) {
            formattedSelections.selectedExcludedProducts = data.excludedProducts.map(prod => ({
                value: prod._id,
                label: prod.name,
            }));
        }

        // Applicable Levels
        if (data?.applicableLevels?.length) {
            formattedSelections.selectedApplicableLevels = data.applicableLevels.map(lvl => ({
                value: lvl._id,
                label: lvl.title,
            }));
        }

        setSelections(formattedSelections);

        // -----------------------------
        // Prepare editData
        // -----------------------------
        const validFields = {
            _id: data._id,
            isHidden: data.isHidden,
            title: data.title,
            couponCode: data.couponCode,
            description: data.description,
            usageType: data.usageType,
            discountPercent: data.discountPercent,
            discountPrice: data.discountPrice,
            applicableQuantityType: data.applicableQuantityType,
            discountAmount: data.discountAmount,
            maxDiscountAmount: data.maxDiscountAmount,
            validityStartDate: formattedStartDate,
            validityEndDate: formattedEndDate,
            termsAndConditions: data.termsAndConditions,
            startTime: data?.startTime,
            endTime: data?.endTime,
            dailyUsageLimit: data?.dailyUsageLimit,
            dayOfWeek: data?.dayOfWeek,
            minOrderAmount: data?.minOrderAmount,
            sizeUpgradeAddon: data?.sizeUpgradeAddon,
            newSizeUpgradeAddon: data?.newSizeUpgradeAddon,
            isComboCategoryCoupon: data?.isComboCategoryCoupon,
            maxAddonsAllowed: data?.maxAddonsAllowed,
            isMrpDiscount: data?.isMrpDiscount,
            orderType: data?.orderType,
            isCashbackCoupon: data?.isCashbackCoupon,
            isFreebieCoupon: data?.isFreebieCoupon,
            freebieProduct: data?.freebieProduct?._id,
            freebieQuantity: data?.freebieQuantity || "",
            status: data?.status,
        };

        const filteredFields = Object.fromEntries(
            Object.entries(validFields).filter(([_, value]) => value !== null && value !== undefined)
        );

        // -----------------------------
        // Handle Excluded Addons & Values
        // -----------------------------
        if (data?.excludedAddons?.length) {
            const uniqueAddonGroups = Array.from(
                new Map(data.excludedAddons.map(a => [a.addonId, a])).values()
            );

            const formattedExcludedAddonGroups = uniqueAddonGroups.map(a => ({
                value: a.addonId,
                label: allAddonList.find(add => add._id === a.addonId)?.title || a.addonTitle || 'Unknown Addon',
            }));

            const formattedExcludedAddonValues = data.excludedAddons.map(a => ({
                value: {
                    addonId: a.addonId,
                    addValueId: a.addonValueId,
                    addonTitle: a.addonTitle,
                    addonValueTitle: a.addonValueTitle,
                },
                label: `${a.addonTitle || 'Unknown Addon'} - ${a.addonValueTitle || 'Unknown Value'}`
            }));

            setSelectedAddonGroups(formattedExcludedAddonGroups);

            // Merge with filteredFields to avoid overwriting
            setEditData(prev => ({
                ...prev,
                ...filteredFields,
                excludedAddonGroups: formattedExcludedAddonGroups.map(opt => ({ _id: opt.value, title: opt.label })),
                excludedAddonValues: formattedExcludedAddonValues.map(opt => opt.value),
                excludedAddons: data.excludedAddons,
            }));
        } else {
            setEditData(filteredFields);
        }
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setCouponId(data._id);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false)
    }

    const handleDeleteCoupon = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: couponId,
            };

            const response = await axios.delete(`coupons`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAllCouponsData(currentPage, recordsPerPage, activeTab, searchText);
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            setOpenDeleteModal(false);
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    // This function is now only used for UI filtering on the currently loaded page
    // It doesn't affect pagination since pagination is handled server-side
    const filterCouponsForDisplay = (coupons) => {
        if (selectedFilter === "ALL") {
            return coupons;
        }
        return coupons.filter((coupon) => {
            if (selectedFilter === "BOGO" && coupon?.isBogoCoupon) return true;
            if (selectedFilter === "UNIVERSAL" && !coupon?.newSizeUpgradeAddon && coupon?.applicableProducts.length === 0 && coupon?.applicableQuantityType === null && coupon?.applicableCategories.length === 0 && coupon?.minOrderAmount === null && coupon?.isBogoCoupon === false && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "CATEGORY" && !coupon?.newSizeUpgradeAddon && coupon?.applicableCategories !== null && coupon?.applicableCategories.length > 0 && coupon?.applicableQuantityType === null && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "PRODUCT" && !coupon?.newSizeUpgradeAddon && coupon?.applicableProducts !== null && coupon?.applicableProducts.length > 0 && coupon?.applicableQuantityType === null && !coupon?.sizeUpgradeAddon && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "SIZEUPGRADE" && (coupon?.sizeUpgradeAddon || coupon?.newSizeUpgradeAddon)) return true;
            if (selectedFilter === "CARTCOUPON" && coupon?.applicableProducts.length === 0 && coupon?.applicableQuantityType === null && coupon?.applicableCategories.length === 0 && coupon?.isBogoCoupon === false && coupon?.minOrderAmount !== null && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "SPECIALPRODUCT" && !coupon?.newSizeUpgradeAddon && coupon?.applicableProducts?.length > 0 && coupon?.applicableQuantityType !== null && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "SPECIALCATEGORY" && !coupon?.newSizeUpgradeAddon && coupon?.applicableCategories?.length > 0 && coupon?.applicableQuantityType !== null && coupon?.primaryComboCategories?.length === 0 && coupon?.secondaryComboCategories?.length === 0) return true;
            if (selectedFilter === "COMBOCOUPON" && coupon?.primaryComboCategories?.length > 0 && coupon?.secondaryComboCategories?.length > 0) return true;
            if (selectedFilter === "FREEBIE" && coupon?.isFreebieCoupon) return true;
            return false;
        });
    };

    const handleSearchProducts = async (e) => {
        e.preventDefault();
        setIsSearchBtnLoading(true);
        setCurrentPage(1); // Reset to first page when searching
        await getAllCouponsData(1, recordsPerPage, activeTab, searchText);
        setIsSearchBtnLoading(false);
    };

    const handleFilterChange = (event) => {
        setSelectedFilter(event.target.value);
        // Don't reset page here since filter is applied client-side on the current page
        // The data is already fetched from server, we just filter what we have
    };

    const handleChange = (key, value) => {
        setSelections((prev) => ({
            ...prev,
            [key]: value,
        }));

        if (key === "selectedApplicableCategories") {
            getProductsList(value);
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        // Update the editCouponData state
        setSizeCouponProducts((prev) => ({
            ...prev,
            [name]: name === "applicableProducts" ? [value] : value,
        }));

        // Update the selectedProducts state
        if (name === "applicableProducts") {
            setSelectedProducts([{ value }]); // Ensuring it's an array with the selected value
        }
    };

    const handleEditStartDate = (date) => {
        if (date) {
            const formattedDate = format(new Date(date), "yyyy-MM-dd");
            setEditData((prev) => ({
                ...prev,
                validityStartDate: formattedDate,
            }));
        } else {
            setEditData((prev) => ({
                ...prev,
                validityStartDate: null,
            }));
        }
    };

    const handleEditEndDate = (date) => {
        if (date) {
            const formattedDate = format(new Date(date), "yyyy-MM-dd");
            setEditData((prev) => ({
                ...prev,
                validityEndDate: formattedDate,
            }));
        } else {
            setEditData((prev) => ({
                ...prev,
                validityEndDate: null,
            }));
        }
    };

    const handleCheckboxChange = (id) => {
        setSelectedCheckbox((prev) => (prev === id ? null : id));
    };

    const handleSubmitEditForm = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // -----------------------------
            // Map selected values
            // -----------------------------
            const selectedIncludedOutlets = selections?.selectedIncludedOutlets?.map(opt => opt.value) || [];
            const selectedExcludedOutlets = selections?.selectedExcludedOutlets?.map(opt => opt.value) || [];
            const selectedApplicableCategories = selections?.selectedApplicableCategories?.map(opt => opt.value) || [];
            const selectedApplicableProducts = selections?.selectedApplicableProducts?.map(opt => opt.value) || [];
            const selectedApplicableLevels = selections?.selectedApplicableLevels?.map(opt => opt.value) || [];
            const selectedDependentCategories = selections?.selectedDependentCategories?.map(opt => opt.value) || [];
            const selectedDependentProducts = selections?.selectedDependentProducts?.map(opt => opt.value) || [];
            const selectedExcludedProducts = selections?.selectedExcludedProducts?.map(opt => opt.value) || [];
            const selectedPrimaryComboCategories = selections?.primaryComboCategories?.map(opt => opt.value) || [];
            const selectedSecondaryComboCategories = selections?.secondaryComboCategories?.map(opt => opt.value) || [];

            // Size Upgrade products
            let selectedProductsData = selectedCheckbox === 'isSizeUpgradeCoupon'
                ? sizeCouponProducts?.applicableProducts.map(c => c)
                : [];

            // -----------------------------
            // Construct updated editData
            // -----------------------------
            let updatedEditData = {
                ...editData,
                includedOutlets: selectedIncludedOutlets,
                excludedOutlets: selectedExcludedOutlets,
                applicableLevels: selectedApplicableLevels,
            };

            if (selectedProductsData?.length > 0) {
                updatedEditData.applicableProducts = selectedProductsData;
            }

            if (selectedPrimaryComboCategories.length > 0) {
                updatedEditData.primaryComboCategories = selectedPrimaryComboCategories;
            }
            if (selectedSecondaryComboCategories.length > 0) {
                updatedEditData.secondaryComboCategories = selectedSecondaryComboCategories;
            }

            // Applicable Categories & Products based on coupon type
            if (['isBogoCoupon', 'isCategoryCoupon', 'isSpecialCategoryCoupon', 'isSizeUpgradeCoupon', 'isCartCoupon'].includes(selectedCheckbox)) {
                updatedEditData.applicableCategories = selectedApplicableCategories.length === 0 ? null : selectedApplicableCategories;
            }

            if (selectedApplicableProducts.length > 0 || selectedCheckbox === 'isSizeUpgradeCoupon' || selectedCheckbox === 'isCartCoupon') {
                updatedEditData.applicableProducts = selectedApplicableProducts.length === 0 ? null : selectedApplicableProducts;
            }

            // Dependent Categories & Products
            if (['isCategoryCoupon', 'isSpecialCategoryCoupon', 'isProductCoupon', 'isSpecialProductCoupon'].includes(selectedCheckbox)) {
                updatedEditData.dependantCategories = selectedDependentCategories.length === 0 ? null : selectedDependentCategories;
                updatedEditData.dependantProducts = selectedDependentProducts.length === 0 ? null : selectedDependentProducts;
            }

            // Excluded products for certain coupon types
            if (['isSpecialCategoryCoupon', 'isCategoryCoupon', 'isSizeUpgradeCoupon', 'isCartCoupon', 'isBogoCoupon', 'isUniversalCoupon', 'isComboCoupon', 'isFreebieCoupon', ''].includes(selectedCheckbox)) {
                updatedEditData.excludedProductList = selectedExcludedProducts?.length === 0 ? null : selectedExcludedProducts;
            }

            if (['isSpecialCategoryCoupon', 'isSpecialProductCoupon'].includes(selectedCheckbox)) {
                delete updatedEditData.excludedProducts;
            }

            // Handle Freebie Coupon specific fields
            if (selectedCheckbox === 'isFreebieCoupon') {
                updatedEditData = {
                    ...updatedEditData,
                    isFreebieCoupon: true,
                    freebieProduct: editData.freebieProduct,
                    freebieQuantity: editData.freebieQuantity || 1,
                    // Clear discount fields for freebie coupons
                    discountPercent: null,
                    discountAmount: null,
                    maxDiscountAmount: null,
                    discountPrice: null,
                    isMrpDiscount: false,
                    isCashbackCoupon: false,
                    applicableQuantityType: null
                };
            } else {
                // If it's NOT a freebie coupon, remove freebie-related fields
                delete updatedEditData.freebieProduct;
                delete updatedEditData.freebieQuantity;
                // Ensure isFreebieCoupon is false
                updatedEditData.isFreebieCoupon = false;
            }

            // -----------------------------
            // Include Excluded Addons & Values
            // -----------------------------
            if (editData?.excludedAddonGroups?.length) {
                delete updatedEditData.excludedAddonGroups
            }

            if (editData?.excludedAddonValues?.length) {
                delete updatedEditData.excludedAddonValues
            }

            // -----------------------------
            // Clean null/undefined fields
            // -----------------------------
            Object.keys(updatedEditData).forEach(key => {
                if (key === 'dayOfWeek') return;

                if (updatedEditData[key] === null || updatedEditData[key] === undefined) {
                    delete updatedEditData[key];
                }

                if (updatedEditData[key] === '' || updatedEditData[key] === undefined) {
                    updatedEditData[key] = null;
                }
            });

            console.log("Updated Edited Data :", updatedEditData);

            // -----------------------------
            // Submit API call
            // -----------------------------
            const response = await axios.put("coupons", updatedEditData, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getAllCouponsData(currentPage, recordsPerPage, activeTab, searchText);
                handleCloseEditModal();
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if ([412, 404].includes(error.response.status)) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.data?.title;
                } else if (error.response.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const editFilteredAddon = selectedProducts
        ? addonList.filter((item) =>
            Array.isArray(selectedProducts)
                ? item.product?._id === selectedProducts[0]?.value
                : item.product?._id === selectedProducts
        )
        : [];

    // Apply filters to the data we have from the server (current page only)
    const filteredActiveCoupons = clicked ? searchActiveData : filterCouponsForDisplay(activeCoupons);
    const filteredInactiveCoupons = clicked ? searchInactiveData : filterCouponsForDisplay(inactiveCoupons);

    // Use the server-provided total pages for pagination
    // The filtered counts are just for display purposes, not for pagination
    const activeCount = filteredActiveCoupons.length;
    const inactiveCount = filteredInactiveCoupons.length;
    
    // For display, we use the filtered data (which is already the current page from server)
    const displayActiveCoupons = filteredActiveCoupons;
    const displayInactiveCoupons = filteredInactiveCoupons;

    const handlRouteChange = () => {
        navigate('/coupons/create-coupon');
    }

    useEffect(() => {
        getAllCouponsData(currentPage, recordsPerPage, activeTab);
        getCategoryList();
        getProductsList();
        getNewSizeAddons();
        getOutlets();
        getLevels();
        getAddonProductsList();
        getAddonList();
    }, []);

    useEffect(() => {
        if (searchText === "") {
            setClicked(false);
            getAllCouponsData(currentPage, recordsPerPage , activeTab);
        }
    }, [searchText]);

    // Handle page change - fetch new data from server
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        getAllCouponsData(pageNumber, recordsPerPage, activeTab, searchText);
    };

    // Handle records per page change
    const handleRecordsPerPageChange = (e) => {
        const newRecordsPerPage = parseInt(e.target.value);
        setRecordsPerPage(newRecordsPerPage);
        getAllCouponsData(1, newRecordsPerPage, activeTab, searchText);
        setCurrentPage(1); // Reset to first page when changing records per page
    };

    // Generate page numbers for pagination using server totalPages
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
            // Show all pages if total pages are less than or equal to maxPagesToShow
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Always show first page
            pageNumbers.push(1);
            
            // Calculate start and end of page range
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            
            // Adjust if at the beginning
            if (currentPage <= 2) {
                endPage = 4;
            }
            
            // Adjust if at the end
            if (currentPage >= totalPages - 1) {
                startPage = totalPages - 3;
            }
            
            // Add ellipsis after first page if needed
            if (startPage > 2) {
                pageNumbers.push('...');
            }
            
            // Add middle pages
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
            
            // Add ellipsis before last page if needed
            if (endPage < totalPages - 1) {
                pageNumbers.push('...');
            }
            
            // Always show last page
            if (totalPages > 1) {
                pageNumbers.push(totalPages);
            }
        }
        
        return pageNumbers;
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />

            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="d-flex align-items-center justify-content-between mb-2 pt-2" role="banner">
                        <Col xs="12" md="6">
                            <h1 className="h5 fw-semibold m-0">COUPONS MANAGEMENT</h1>
                        </Col>

                        <Col xs="12" md="6" className="text-md-end mt-2 mt-md-0">
                            {(couponAccess?.includes("Coupons:add   ") || email === 'contact@xpansecafe.com') && (
                                <Button
                                    className="px-4 py-2 fw-semibold border-0 w-50"
                                    onClick={handlRouteChange}
                                    aria-label="Create new coupon"
                                    style={{
                                        background: 'rgba(40, 167, 69, 0.2)',
                                        backdropFilter: 'blur(10px)',
                                        borderRadius: '16px',
                                        border: '1px solid rgba(40, 167, 69, 0.3)',
                                        color: '#198754',
                                        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)'
                                    }}
                                >
                                    <i className="bi bi-plus-square me-2" aria-hidden="true"></i>
                                    Create New Coupon
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <hr />
                    </Row>

                    <Row className='mb-2'>
                        <Col md={5} lg={6}>
                            <Form.Select
                                aria-label="Filter coupons"
                                onChange={handleFilterChange}
                                value={selectedFilter}
                                className=" text-center"
                                style={{ textAlignLast: 'center' }}
                            >
                                <option value="ALL">ALL COUPONS</option>
                                <option value="CARTCOUPON">CART COUPON</option>
                                <option value="BOGO">BOGO COUPON</option>
                                <option value="PRODUCT">PRODUCT COUPON</option>
                                <option value="CATEGORY">CATEGORY COUPON</option>
                                <option value="UNIVERSAL">UNIVERSAL COUPON</option>
                                <option value="SIZEUPGRADE">SIZE UPGRADE COUPON</option>
                                <option value="SPECIALPRODUCT">SPECIAL PRODUCT COUPON</option>
                                <option value="SPECIALCATEGORY">SPECIAL CATEGORY COUPON</option>
                                <option value="COMBOCOUPON">COMBO COUPON</option>
                                <option value="FREEBIE">FREEBIE COUPON</option>
                            </Form.Select>
                        </Col>
                        <Col>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control"
                                    placeholder="Search by coupon code or coupon title"
                                />
                                <button
                                    className="btn btn-primary w-25"
                                    type="button"
                                    onClick={handleSearchProducts}
                                >
                                    {isSearchBtnLoading ? <Spinner size="sm" /> : <><i className="ri-search-line"></i> Search</>}
                                </button>
                            </div>
                        </Col>
                    </Row>

                    {/* Pagination Records Per Page Selector and Summary */}
                    <Row className="mb-2 align-items-center">
                        <Col md={4}>
                            <div className="d-flex align-items-center">
                                <span className="me-2 text-muted">Show:</span>
                                <Form.Select 
                                    value={recordsPerPage} 
                                    onChange={handleRecordsPerPageChange}
                                    style={{ width: '80px' }}
                                    size="sm"
                                >
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </Form.Select>
                                <span className="ms-2 text-muted">per page</span>
                            </div>
                        </Col>
                        <Col md={4}>
                            {/* Pagination Component */}
                            {totalPages > 0 && (
                                <Row className="mt-1">
                                    <Col className="d-flex justify-content-center">
                                        <div className="d-flex flex-column align-items-center">
                                            {/* Pagination Controls */}
                                            <Pagination className="mb-1">
                                                {/* First Page */}
                                                <Pagination.First 
                                                    onClick={() => handlePageChange(1)} 
                                                    disabled={currentPage === 1}
                                                />
                                                
                                                {/* Previous Page */}
                                                <Pagination.Prev 
                                                    onClick={() => handlePageChange(currentPage - 1)} 
                                                    disabled={currentPage === 1}
                                                />
                                                
                                                {/* Page Numbers */}
                                                {getPageNumbers().map((pageNum, index) => (
                                                    pageNum === '...' ? (
                                                        <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                                                    ) : (
                                                        <Pagination.Item 
                                                            key={pageNum}
                                                            active={pageNum === currentPage}
                                                            onClick={() => handlePageChange(pageNum)}
                                                        >
                                                            {pageNum}
                                                        </Pagination.Item>
                                                    )
                                                ))}
                                                
                                                {/* Next Page */}
                                                <Pagination.Next 
                                                    onClick={() => handlePageChange(currentPage + 1)} 
                                                    disabled={currentPage === totalPages}
                                                />
                                                
                                                {/* Last Page */}
                                                <Pagination.Last 
                                                    onClick={() => handlePageChange(totalPages)} 
                                                    disabled={currentPage === totalPages}
                                                />
                                            </Pagination>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                        <Col md={4} className="text-end">
                            <span className="text-muted">
                                Showing {((currentPage - 1) * recordsPerPage) + 1} to {Math.min(currentPage * recordsPerPage, totalRecords)} of {totalRecords} {activeTab.toLowerCase()} coupons
                            </span>
                        </Col>
                    </Row>

                    <Row className='justify-content-end' style={{ backgroundColor: "white" }}>
                        <div className="d-flex justify-content-center gap-2 mb-4">
                            <Button
                                variant="outline-secondary"
                                className={`w-50 ${activeTab === "ACTIVE" ? "active" : ""}`}
                                onClick={() => handleTabChange("ACTIVE")}
                                style={{
                                    borderBottom: activeTab === "ACTIVE" ? "2px solid #bcbcbd" : "1px solid #bcbcbd",
                                    background: activeTab === "ACTIVE" ? "#e7e9eb" : "none",
                                    borderRadius: "5px",
                                }}
                            >
                                ACTIVE ({activeCount})
                            </Button>
                            <Button
                                variant="outline-secondary"
                                className={`w-50 ${activeTab === "INACTIVE" ? "active" : ""}`}
                                onClick={() => handleTabChange("INACTIVE")}
                                style={{
                                    borderBottom: activeTab === "INACTIVE" ? "2px solid #bcbcbd" : "1px solid #bcbcbd",
                                    background: activeTab === "INACTIVE" ? "#e7e9eb" : "none",
                                    borderRadius: "5px",
                                }}
                            >
                                INACTIVE ({inactiveCount})
                            </Button>
                        </div>

                        {/* Active Coupons */}
                        {activeTab === "ACTIVE" && (
                            <Row>
                                {loading ? (
                                    // Skeleton Loading for Active Coupons
                                    Array.from({ length: 8 }).map((_, index) => (
                                        <Col key={`skeleton-${index}`} sm="12" md="6" lg="4" xl="3" className="mb-4">
                                            <Card className='shadow-sm w-100' style={{ borderRadius: '10px' }}>
                                                <Row style={{ height: '190px' }}>
                                                    {/* Left colored stripe skeleton */}
                                                    <Col lg="2" md="2" sm="2" className='d-flex align-items-center justify-content-center'
                                                        style={{
                                                            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                            backgroundSize: '200% 100%',
                                                            animation: 'skeletonPulse 1.5s infinite',
                                                            borderTopLeftRadius: '10px',
                                                            borderBottomLeftRadius: '10px',
                                                            borderRight: '2.3px dotted #e0e0e0'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                writingMode: 'sideways-lr',
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                height: '60px'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '80%',
                                                                    height: '12px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    margin: '0 auto'
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    {/* Right content area skeleton */}
                                                    <Col lg="10" md="10" sm="10" className='pe-3'>
                                                        {/* Header section skeleton */}
                                                        <div className='mt-2 d-flex justify-content-between align-items-center pe-1'>
                                                            <div
                                                                style={{
                                                                    width: '80px',
                                                                    height: '16px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '50%',
                                                                        marginRight: '8px'
                                                                    }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Title skeleton */}
                                                        <div className='mt-2'>
                                                            <div
                                                                style={{
                                                                    width: '70%',
                                                                    height: '14px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '8px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '50%',
                                                                    height: '14px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Divider */}
                                                        <div className='pe-1 mt-2' style={{ borderTop: '1px dashed #e0e0e0', paddingTop: '8px' }}>
                                                            {/* Categories skeleton */}
                                                            <div
                                                                style={{
                                                                    width: '90%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '80%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '8px'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Additional info skeletons */}
                                                        <div className='mt-2'>
                                                            <div
                                                                style={{
                                                                    width: '85%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '75%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '70%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))
                                ) : displayActiveCoupons?.length === 0 ? (
                                    // Empty State
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
                                        <div className="text-center">
                                            <div className="text-muted mb-2">
                                                <i className="fas fa-ticket-alt" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                                            </div>
                                            <p className="text-muted">No active coupons found</p>
                                        </div>
                                    </div>
                                ) : (
                                    displayActiveCoupons?.map((item, index) => (
                                        <Col key={index} sm="12" md="6" lg="4" xl="3" className="mb-4">
                                            <Card className='shadow-sm w-100' style={{ borderRadius: '10px' }}>
                                                <Row style={{ height: '190px' }}>
                                                    <Col lg="2" md="2" sm="2" className='d-flex align-items-center justify-content-center'
                                                        style={{
                                                            background: item?.isBogoCoupon
                                                                ? 'linear-gradient(45deg, #3F51B5, #5C6BC0)' // Muted Blue for BOGO
                                                                : item?.sizeUpgradeAddon || item?.newSizeUpgradeAddon
                                                                    ? 'linear-gradient(45deg, #388E3C, #66BB6A)' // Earthy Green for Size Upgrade
                                                                    : item?.isFreebieCoupon
                                                                        ? 'linear-gradient(45deg, #FF9800, #FFB74D)' // Orange for Freebie
                                                                        : 'linear-gradient(45deg, #FF7043, #FF8A65)', // Warm Coral for default
                                                            borderTopLeftRadius: '10px',
                                                            borderBottomLeftRadius: '10px',
                                                            borderRight: '2.3px dotted white'
                                                        }}
                                                    >
                                                        <span className='fw-semibold p-2' style={{ display: 'flex', flexDirection: 'column', writingMode: 'sideways-lr', textAlign: 'center', color: 'white' }}>
                                                            {item?.discountAmount !== null && `₹ ${item?.discountAmount} OFF`}
                                                            {item?.discountPrice !== null && `₹ ${item?.discountPrice}`}
                                                            {item?.discountPercent !== null && `${item?.discountPercent}% OFF`}
                                                            {(item?.sizeUpgradeAddon || item?.newSizeUpgradeAddon) && "Size Upgrade Coupon"}
                                                            {item?.isBogoCoupon && (
                                                                <span className="ms-2">BOGO COUPON</span>
                                                            )}
                                                            {item?.isFreebieCoupon && (
                                                                <span className="ms-2">FREEBIE COUPON</span>
                                                            )}
                                                        </span>
                                                    </Col>
                                                    <Col lg="10" md="10" sm="10" className='pe-3'>
                                                        <div className='mt-2 d-flex justify-content-between align-items-center pe-1'>
                                                            <h6 className='fw-bold' style={{ color: '#FC8019' }}>{item?.couponCode}</h6>
                                                            <div className="d-flex align-items-center">
                                                                {item?.isMrpDiscount === true && (
                                                                    <img src="/images/mrp.jpeg" alt="" style={{ width: '30px', height: '30px' }} />
                                                                )}
                                                                {item?.isComboCategoryCoupon === true && (
                                                                    <img src="/images/combo.png" alt="" style={{ width: '30px', height: '30px' }} />
                                                                )}
                                                                {/* Three Dots Icon for Actions */}
                                                                <div className="dropdown ms-2" style={{ cursor: 'pointer' }}>
                                                                    <i
                                                                        className="bi bi-three-dots-vertical"
                                                                        id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ fontSize: '18px', color: '#6c757d' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                        {(couponAccess?.includes("Coupons:get") || email === 'contact@xpansecafe.com') && (
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item text-success"
                                                                                    onClick={() => handleOpenViewModal(item)}
                                                                                >
                                                                                    View
                                                                                </button>
                                                                            </li>
                                                                        )}
                                                                        {(couponAccess?.includes("Coupons:update") || email === 'contact@xpansecafe.com') && (
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item text-primary"
                                                                                    onClick={() => handleOpenEditModal(item)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </li>
                                                                        )}
                                                                        {(couponAccess?.includes("Coupons:delete") || email === 'contact@xpansecafe.com') && (
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item text-danger"
                                                                                    onClick={() => handleDeleteModal(item)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <h6>{item?.title}</h6>
                                                        </div>

                                                        <div className='pe-1 mb-1' style={{ borderTop: '1px dashed #a8a0a0' }}>
                                                            {(!item?.freebieProduct) && (
                                                                <p className='mb-0 mt-1' style={{ fontSize: '10px' }}><span className='fw-semibold'>Applicable Categories : </span>
                                                                    {item?.applicableCategories?.length > 0 ? (
                                                                        (() => {
                                                                            const categoriesText = item.applicableCategories
                                                                                .map(cat => cat?.name)
                                                                                .join(", ");
                                                                            const words = categoriesText.split(" ");
                                                                            return words.length > maxWords ? (
                                                                                <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                            ) : (
                                                                                <span>{categoriesText}.</span>
                                                                            );
                                                                        })()
                                                                    ) : (
                                                                        " Applicable For All Categories"
                                                                    )}
                                                                </p>
                                                            )}
                                                        </div>

                                                        {(item?.freebieProduct) && (
                                                            <div>
                                                                <p className='mb-0' style={{ fontSize: '10px' }}>
                                                                    <span className='fw-semibold'>Freebie Product: </span>
                                                                    {item?.freebieProduct ? item?.freebieProduct?.name : "N/A"}
                                                                </p>
                                                                <p className='mb-0' style={{ fontSize: '10px' }}>
                                                                    <span className='fw-semibold'>Freebie Quanityt: </span>
                                                                    {item?.freebieQuantity ? item?.freebieQuantity : "N/A"}
                                                                </p>
                                                            </div>
                                                        )}

                                                        {(!item?.freebieProduct > 0) && (
                                                            <div>
                                                                <p className='mb-0' style={{ fontSize: '10px' }}><span className='fw-semibold'>Applicable Products: </span>
                                                                    {" "}
                                                                    {item?.applicableProducts?.length > 0 ? (
                                                                        (() => {
                                                                            const productsText = item.applicableProducts.map(prod => prod?.name).join(", ");
                                                                            const words = productsText.split(" ");
                                                                            return words.length > maxWords ? (
                                                                                <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                            ) : (
                                                                                <span>{productsText}.</span>
                                                                            );
                                                                        })()
                                                                    ) : (
                                                                        " Applicable For All Products"
                                                                    )}
                                                                </p>
                                                            </div>
                                                        )}
                                                        <div>
                                                            <p className='mb-0 mt-1' style={{ fontSize: '10px' }}><span className='fw-semibold'>Excluding Outlets : </span>
                                                                {" "}
                                                                {item?.excludedOutlets?.length > 0 ? (
                                                                    (() => {
                                                                        const outletsText = item.excludedOutlets.map(outlet => outlet?.name).join(", ");
                                                                        const words = outletsText.split(" ");
                                                                        return words.length > maxWords ? (
                                                                            <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                        ) : (
                                                                            <span>{outletsText}.</span>
                                                                        );
                                                                    })()
                                                                ) : (
                                                                    " Applicable In All Outlets"
                                                                )}
                                                            </p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))
                                )}
                            </Row>
                        )}

                        {/* Inactive Coupons */}
                        {activeTab === "INACTIVE" && (
                            <Row>
                                {loading ? (
                                    // Skeleton Loading for Inactive Coupons
                                    Array.from({ length: 8 }).map((_, index) => (
                                        <Col key={`skeleton-inactive-${index}`} sm="12" md="6" lg="4" xl="3" className="mb-4">
                                            <Card className="shadow-sm w-100" style={{ borderRadius: '10px', opacity: '0.8', position: 'relative' }}>
                                                <Row style={{ height: '190px' }}>
                                                    {/* Left Gray Stripe Skeleton */}
                                                    <Col lg="2" md="2" sm="2" className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                            backgroundSize: '200% 100%',
                                                            animation: 'skeletonPulse 1.5s infinite',
                                                            borderTopLeftRadius: '10px',
                                                            borderBottomLeftRadius: '10px'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                writingMode: 'sideways-lr',
                                                                textAlign: 'center',
                                                                width: '100%',
                                                                height: '60px'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '80%',
                                                                    height: '12px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    margin: '0 auto'
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>

                                                    {/* Right Content Area Skeleton */}
                                                    <Col lg="10" md="10" sm="10" className="pe-3">
                                                        {/* Header Section Skeleton */}
                                                        <div className="mt-2 d-flex justify-content-between align-items-center pe-1">
                                                            <div
                                                                style={{
                                                                    width: '80px',
                                                                    height: '16px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '50%',
                                                                        marginRight: '8px'
                                                                    }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                        backgroundSize: '200% 100%',
                                                                        animation: 'skeletonPulse 1.5s infinite',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Title Skeleton */}
                                                        <div className="mt-2">
                                                            <div
                                                                style={{
                                                                    width: '70%',
                                                                    height: '14px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '8px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '50%',
                                                                    height: '14px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Divider */}
                                                        <div className="pe-1 mt-2" style={{ borderTop: '1px dashed #d0d0d0', paddingTop: '8px' }}>
                                                            {/* Categories Skeleton */}
                                                            <div
                                                                style={{
                                                                    width: '90%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '80%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '8px'
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Additional Info Skeletons */}
                                                        <div className="mt-2">
                                                            <div
                                                                style={{
                                                                    width: '85%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '75%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px',
                                                                    marginBottom: '6px'
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: '70%',
                                                                    height: '10px',
                                                                    background: 'linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'skeletonPulse 1.5s infinite',
                                                                    borderRadius: '4px'
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))
                                ) : displayInactiveCoupons?.length === 0 ? (
                                    // Empty State for Inactive Coupons
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px', width: '100%' }}>
                                        <div className="text-center">
                                            <div className="text-muted mb-2">
                                                <i className="fas fa-ticket-alt" style={{ fontSize: '3rem', opacity: 0.3 }}></i>
                                            </div>
                                            <p className="text-muted">No inactive coupons found</p>
                                        </div>
                                    </div>
                                ) : (
                                    displayInactiveCoupons?.map((item, index) => (
                                        <Col key={index} sm="12" md="6" lg="4" xl="3" className="mb-4">
                                            <Card className="shadow-sm w-100" style={{ borderRadius: '10px', opacity: '0.8', position: 'relative' }}>
                                                <Row style={{ height: '190px' }}>
                                                    {/* Left Gradient Section */}
                                                    <Col lg="2" md="2" sm="2" className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            background: item?.isBogoCoupon
                                                                ? 'linear-gradient(45deg, #9E9E9E, #757575)' // Gray for BOGO
                                                                : item?.sizeUpgradeAddon || item?.newSizeUpgradeAddon
                                                                    ? 'linear-gradient(45deg, #BDBDBD, #9E9E9E)' // Light Gray for Size Upgrade
                                                                    : item?.isFreebieCoupon
                                                                        ? 'linear-gradient(45deg, #E0E0E0, #BDBDBD)' // Light Gray for Freebie
                                                                        : 'linear-gradient(45deg, #E0E0E0, #BDBDBD)', // Default Gray
                                                            borderTopLeftRadius: '10px',
                                                            borderBottomLeftRadius: '10px'
                                                        }}
                                                    >
                                                        <span className="fw-semibold p-2" style={{ display: 'flex', flexDirection: 'column', writingMode: 'sideways-lr', textAlign: 'center', color: 'white' }}>
                                                            {item?.discountAmount !== null && `₹ ${item?.discountAmount} OFF`}
                                                            {item?.discountPrice !== null && `₹ ${item?.discountPrice}`}
                                                            {item?.discountPercent !== null && `${item?.discountPercent}% OFF`}
                                                            {(item?.sizeUpgradeAddon || item?.newSizeUpgradeAddon) && "Size Upgrade Coupon"}
                                                            {item?.isBogoCoupon && <span className="ms-2">BOGO COUPON</span>}
                                                            {item?.isFreebieCoupon && <span className="ms-2">FREEBIE COUPON</span>}
                                                        </span>
                                                    </Col>
                                                    {/* Right Content Section */}
                                                    <Col lg="10" md="10" sm="10" className="pe-3">
                                                        {/* Coupon Code and Icons */}
                                                        <div className="mt-2 d-flex justify-content-between align-items-center pe-1">
                                                            <h6 className="fw-bold" style={{ color: '#9E9E9E' }}>{item?.couponCode}</h6>
                                                            <div className="d-flex align-items-center">
                                                                {item?.isMrpDiscount === true && (
                                                                    <img src="/images/mrp.jpeg" alt="" style={{ width: '30px', height: '30px' }} />
                                                                )}
                                                                {item?.isComboCategoryCoupon === true && (
                                                                    <img src="/images/combo.png" alt="" style={{ width: '30px', height: '30px' }} />
                                                                )}
                                                                {/* Three Dots Icon for Actions */}
                                                                <div className="dropdown ms-2" style={{ cursor: 'pointer' }}>
                                                                    <i
                                                                        className="bi bi-three-dots-vertical"
                                                                        id="dropdownMenuButton"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ fontSize: '18px', color: '#9E9E9E' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton" style={{ zIndex: 1050, position: 'absolute' }}>
                                                                        <li>
                                                                            {(couponAccess?.includes("Coupons:get") || email === "contact@xpansecafe.com") && (
                                                                                <button
                                                                                    className="dropdown-item text-success"
                                                                                    onClick={() => handleOpenViewModal(item)}
                                                                                >
                                                                                    View
                                                                                </button>
                                                                            )}
                                                                        </li>
                                                                        <li>
                                                                            {(couponAccess?.includes("Coupons:update") || email === "contact@xpansecafe.com") && (
                                                                                <button
                                                                                    className="dropdown-item text-primary"
                                                                                    onClick={() => handleOpenEditModal(item)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            )}
                                                                        </li>
                                                                        <li>
                                                                            {(couponAccess?.includes("Coupons:delete") || email === "contact@xpansecafe.com") && (
                                                                                <button className="dropdown-item text-danger" onClick={() => handleDeleteModal(item)}>
                                                                                    Delete
                                                                                </button>
                                                                            )}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Coupon Title */}
                                                        <div>
                                                            <h6 style={{ color: '#757575' }}>{item?.title}</h6>
                                                        </div>
                                                        {/* Applicable Categories */}
                                                        <div className="pe-1" style={{ borderTop: '1px dashed #BDBDBD' }}>
                                                            <p style={{ fontSize: '10px' }}>
                                                                <span className="fw-semibold">Applicable Categories: </span>
                                                                {item?.applicableCategories?.length > 0 ? (
                                                                    (() => {
                                                                        const categoriesText = item.applicableCategories
                                                                            .map(cat => cat?.name)
                                                                            .join(", ");
                                                                        const words = categoriesText.split(" ");
                                                                        return words.length > maxWords ? (
                                                                            <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                        ) : (
                                                                            <span>{categoriesText}.</span>
                                                                        );
                                                                    })()
                                                                ) : (
                                                                    " Applicable For All Categories"
                                                                )}
                                                            </p>
                                                        </div>
                                                        {/* Applicable Products and Excluded Outlets */}
                                                        <div>
                                                            <p style={{ fontSize: '10px' }}>
                                                                <span className="fw-semibold">Applicable Products: </span>
                                                                {item?.applicableProducts?.length > 0 ? (
                                                                    (() => {
                                                                        const productsText = item.applicableProducts.map(prod => prod?.name).join(", ");
                                                                        const words = productsText.split(" ");
                                                                        return words.length > maxWords ? (
                                                                            <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                        ) : (
                                                                            <span>{productsText}.</span>
                                                                        );
                                                                    })()
                                                                ) : (
                                                                    " Applicable For All Products"
                                                                )}
                                                            </p>
                                                            <p style={{ fontSize: '10px' }}>
                                                                <span className="fw-semibold">Excluding Outlets: </span>
                                                                {item?.excludedOutlets?.length > 0 ? (
                                                                    (() => {
                                                                        const outletsText = item.excludedOutlets.map(outlet => outlet?.name).join(", ");
                                                                        const words = outletsText.split(" ");
                                                                        return words.length > maxWords ? (
                                                                            <span>{words.slice(0, maxWords).join(" ")}...</span>
                                                                        ) : (
                                                                            <span>{outletsText}.</span>
                                                                        );
                                                                    })()
                                                                ) : (
                                                                    " Applicable In All Outlets"
                                                                )}
                                                            </p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))
                                )}
                            </Row>
                        )}

                        {/* Pagination Component - Only show if there are pages */}
                        {totalPages > 0 && (
                            <Row className="mt-4 mb-3">
                                <Col className="d-flex justify-content-center">
                                    <div className="d-flex flex-column align-items-center">
                                        {/* Pagination Controls */}
                                        <Pagination className="mb-2">
                                            {/* First Page */}
                                            <Pagination.First 
                                                onClick={() => handlePageChange(1)} 
                                                disabled={currentPage === 1}
                                            />
                                            
                                            {/* Previous Page */}
                                            <Pagination.Prev 
                                                onClick={() => handlePageChange(currentPage - 1)} 
                                                disabled={currentPage === 1}
                                            />
                                            
                                            {/* Page Numbers */}
                                            {getPageNumbers().map((pageNum, index) => (
                                                pageNum === '...' ? (
                                                    <Pagination.Ellipsis key={`ellipsis-${index}`} disabled />
                                                ) : (
                                                    <Pagination.Item 
                                                        key={pageNum}
                                                        active={pageNum === currentPage}
                                                        onClick={() => handlePageChange(pageNum)}
                                                    >
                                                        {pageNum}
                                                    </Pagination.Item>
                                                )
                                            ))}
                                            
                                            {/* Next Page */}
                                            <Pagination.Next 
                                                onClick={() => handlePageChange(currentPage + 1)} 
                                                disabled={currentPage === totalPages}
                                            />
                                            
                                            {/* Last Page */}
                                            <Pagination.Last 
                                                onClick={() => handlePageChange(totalPages)} 
                                                disabled={currentPage === totalPages}
                                            />
                                        </Pagination>
                                        
                                        {/* Page Info */}
                                        <div className="text-muted">
                                            Page {currentPage} of {totalPages}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        )}

                        {/* VIEW COUPON DETAILS MODAL */}
                        {openViewModal ? (
                            <Modal
                                centered
                                show={openViewModal}
                                onHide={() => setOpenViewModal(false)}
                                size="lg"
                                aria-labelledby="coupon-modal"
                            >
                                <Modal.Body
                                    style={{
                                        border: "4px dashed #4CAF50",
                                        borderRadius: "15px",
                                        background: "linear-gradient(135deg, #f9f9f9, #e3f2fd)",
                                        padding: "20px",
                                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                                        position: "relative",
                                        overflow: "hidden",
                                    }}
                                >

                                    {/* Coupon Header */}
                                    <div className="text-center mb-4">
                                        <h2
                                            style={{
                                                background: "linear-gradient(90deg, #4CAF50, #009688)",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                fontWeight: "bold",
                                                textTransform: "uppercase",
                                                letterSpacing: "1.5px",
                                                fontSize: "1.6rem",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {singleCouponDetails?.title || "Exclusive Coupon"}
                                        </h2>
                                    </div>

                                    {/* Coupon Code Section */}
                                    <div
                                        className="text-center mb-4 w-100"
                                        style={{
                                            background: "#fff",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            border: "2px dashed #4CAF50",
                                            display: "inline-block",
                                            margin: "0 auto",
                                        }}
                                    >
                                        <span
                                            className="badge p-3 w-50"
                                            style={{
                                                background: "#09a5f7",
                                                color: "#fff",
                                                fontSize: "1.1rem",
                                                fontWeight: "bold",
                                                letterSpacing: "2px",
                                                textTransform: "uppercase",
                                                borderRadius: "25px",
                                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                            }}
                                        >
                                            ★ {singleCouponDetails?.couponCode || "COUPON123"} ★
                                        </span>
                                    </div>

                                    {/* Discount Section */}
                                    {(singleCouponDetails?.discountAmount ||
                                        singleCouponDetails?.discountPercent ||
                                        singleCouponDetails?.discountPrice) && (
                                            <div className="text-center mb-4">
                                                <h3
                                                    style={{
                                                        color: "#28a745",
                                                        fontWeight: "bold",
                                                        fontSize: "1.5rem",
                                                        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
                                                    }}
                                                >
                                                    {singleCouponDetails?.discountAmount
                                                        ? `${singleCouponDetails.discountAmount} Rs OFF`
                                                        : singleCouponDetails?.discountPercent
                                                            ? `${singleCouponDetails.discountPercent}% OFF`
                                                            : `₹. ${singleCouponDetails.discountPrice}`}
                                                </h3>
                                            </div>
                                        )}

                                    {/* Freebie Coupon Section */}
                                    {singleCouponDetails?.isFreebieCoupon && (
                                        <div className="text-center mb-4">
                                            <h3
                                                style={{
                                                    color: "#FF9800",
                                                    fontWeight: "bold",
                                                    fontSize: "1.5rem",
                                                    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
                                                }}
                                            >
                                                🎁 FREEBIE COUPON
                                            </h3>
                                            <p className="text-muted">
                                                {singleCouponDetails?.freebieProduct?.name ?
                                                    `Get ${singleCouponDetails.freebieQuantity || 1} ${singleCouponDetails.freebieProduct.name} free`
                                                    : "Free product offer"}
                                            </p>
                                        </div>
                                    )}

                                    {/* Coupon Details */}
                                    <div
                                        style={{
                                            background: "#fff",
                                            padding: "20px",
                                            borderRadius: "10px",
                                            border: "2px dashed #4CAF50",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* Usage Type */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Usage Type:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.usageType || "N/A"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Is This Hidden:</span>{" "}
                                                    {singleCouponDetails?.isHidden ? (
                                                        <span className="text-danger fw-semibold">YES</span>
                                                    ) : (
                                                        <span className="text-success fw-semibold">NO</span>
                                                    )}
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Addon Name */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Addon Name:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.sizeUpgradeAddon?.addonTitle || singleCouponDetails?.newSizeUpgradeAddon?.title || "N/A"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Applicable Qty Type:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.applicableQuantityType || "N/A"}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Validity */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Valid From:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.validityStartDate
                                                            ? convertDate(updatedDate(singleCouponDetails.validityStartDate))
                                                            : "No Validity"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Valid Until:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.validityEndDate
                                                            ? convertDate(updatedDate(singleCouponDetails.validityEndDate))
                                                            : "No Validity"}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Time and Day */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Start Time:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.startTime || "No Start Time"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">End Time:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.endTime || "No End Time"}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Day of Week */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Day of Week:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.dayOfWeek !== undefined && singleCouponDetails?.dayOfWeek !== null
                                                            ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][singleCouponDetails?.dayOfWeek]
                                                            : "No Specific Day"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Max Addons Allowed:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.maxAddonsAllowed === null
                                                            ? "No Restrictions"
                                                            : singleCouponDetails?.maxAddonsAllowed}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Min and Max Discount */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Min Order Amount:</span>{" "}
                                                    <span className="text-success">
                                                        {singleCouponDetails?.minOrderAmount
                                                            ? `₹. ${singleCouponDetails?.minOrderAmount}`
                                                            : "No Min Order"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Max Discount Amount:</span>{" "}
                                                    <span className="text-success">
                                                        {singleCouponDetails?.maxDiscountAmount
                                                            ? `₹. ${singleCouponDetails?.maxDiscountAmount}`
                                                            : "No Max Discount"}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* MRP Coupon */}
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Is MRP Coupon:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.isMrpDiscount ? "YES" : "NO"}
                                                    </span>
                                                </h6>
                                            </Col>
                                            <Col md={6}>
                                                <h6>
                                                    <span className="text-muted fw-semibold">Order Type:</span>{" "}
                                                    <span className="text-secondary">
                                                        {singleCouponDetails?.orderType ? singleCouponDetails?.orderType : "ALL"}
                                                    </span>
                                                </h6>
                                            </Col>
                                        </Row>

                                        {/* Freebie Details */}
                                        {singleCouponDetails?.isFreebieCoupon && (
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <h6>
                                                        <span className="text-muted fw-semibold">Freebie Product:</span>{" "}
                                                        <span className="text-success fw-semibold">
                                                            {singleCouponDetails?.freebieProduct?.name || "N/A"}
                                                        </span>
                                                    </h6>
                                                </Col>
                                                <Col md={6}>
                                                    <h6>
                                                        <span className="text-muted fw-semibold">Freebie Quantity:</span>{" "}
                                                        <span className="text-success fw-semibold">
                                                            {singleCouponDetails?.freebieQuantity || 1}
                                                        </span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                        )}

                                        {singleCouponDetails.dailyUsageLimit && (
                                            <Row>
                                                <Col md="6">
                                                    <h6>
                                                        <span className="text-muted fw-semibold">Daily Usage Limit:</span>{" "}
                                                        <span className="text-secondary">
                                                            {singleCouponDetails?.dailyUsageLimit || "N/A"}
                                                        </span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                        )}
                                    </div>

                                    {/* Applicable Products */}
                                    {singleCouponDetails?.applicableProducts?.length === 0 && !singleCouponDetails?.freebieProduct && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed purple",
                                            }}
                                        >
                                            {singleCouponDetails?.applicableCategories?.length > 0 ? (
                                                <div className="d-flex align-items-center w-100">
                                                    <h6 style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }} className="fw-semibold text-muted mt-2">
                                                        Applicable Categories :
                                                    </h6>
                                                    <div
                                                        className="d-flex flex-wrap gap-1"
                                                        style={{
                                                            maxHeight: singleCouponDetails?.applicableCategories?.length > 8 ? "120px" : "auto",
                                                            overflowY: singleCouponDetails?.applicableCategories?.length > 8 ? "auto" : "visible",
                                                            flex: 1
                                                        }}
                                                    >
                                                        {singleCouponDetails?.applicableCategories?.map((cat, index) => (
                                                            <span
                                                                key={index}
                                                                style={{
                                                                    background: "#e8f5e9",
                                                                    color: "#388e3c",
                                                                    borderRadius: "16px",
                                                                    padding: "4px 8px",
                                                                    fontWeight: "500",
                                                                    fontSize: "11px",
                                                                    alignSelf: "center",
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {cat.name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <span
                                                    className="text-success fw-semibold"
                                                    style={{
                                                        fontSize: "11px",
                                                        alignSelf: "center",
                                                        background: "#e8f5e9",
                                                        color: "#388e3c",
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    On All Categories In Our Store
                                                </span>
                                            )}
                                        </Col>
                                    )}

                                    {/* Applicable Levels */}
                                    {singleCouponDetails?.applicableLevels?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed green",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Applicable Levels :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.applicableLevels?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.applicableLevels?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.applicableLevels.map((level, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#e3f2fd",
                                                                color: "#1976d2",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {level.title}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Applicable Products */}
                                    {singleCouponDetails?.applicableCategories?.length === 0 && !singleCouponDetails?.freebieProduct && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed purple",
                                            }}
                                        >
                                            {singleCouponDetails?.applicableProducts?.length > 0 ? (
                                                <div className="d-flex align-items-center w-100">
                                                    <h6 className="text-muted mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                        Applicable Products :
                                                    </h6>
                                                    <div
                                                        className="d-flex flex-wrap gap-1"
                                                        style={{
                                                            maxHeight: singleCouponDetails?.applicableProducts?.length > 8 ? "120px" : "auto",
                                                            overflowY: singleCouponDetails?.applicableProducts?.length > 8 ? "auto" : "visible",
                                                            flex: 1
                                                        }}
                                                    >
                                                        {singleCouponDetails?.applicableProducts.map((product, index) => (
                                                            <span
                                                                key={index}
                                                                style={{
                                                                    background: "#e3f2fd",
                                                                    color: "#1976d2",
                                                                    borderRadius: "16px",
                                                                    padding: "5px 10px",
                                                                    fontWeight: "500",
                                                                    fontSize: "11px",
                                                                    alignSelf: "center",
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {product?.name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <span
                                                    className="text-success fw-semibold"
                                                    style={{
                                                        fontSize: "11px",
                                                        alignSelf: "center",
                                                        background: "#e8f5e9",
                                                        color: "#388e3c",
                                                        padding: "10px",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    On All Products In Our Store
                                                </span>
                                            )}
                                        </Col>
                                    )}

                                    {/* Excluded Outlets */}
                                    {singleCouponDetails?.excludedOutlets?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed red",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Excluded Outlets :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.excludedOutlets?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.excludedOutlets?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.excludedOutlets.map((outlet, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#ffebee",
                                                                color: "#d32f2f",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {outlet?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Excluded Addons */}
                                    {singleCouponDetails?.excludedAddons?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed orange",
                                            }}
                                        >
                                            <div className="d-flex align-items-center flex-wrap w-100">
                                                <h6 className="text-muted mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Excluded Addons :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.excludedAddons?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.excludedAddons?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.excludedAddons.map((addon, index) => (
                                                        <div key={index} className="d-flex align-items-center">
                                                            <span
                                                                style={{
                                                                    background: "#fff3e0",
                                                                    color: "#f57c00",
                                                                    borderRadius: "16px",
                                                                    padding: "5px 10px",
                                                                    fontWeight: "500",
                                                                    fontSize: "11px",
                                                                    border: "1px solid #ffb74d",
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                <strong>{addon?.addonTitle}</strong>: {addon?.addonValueTitle}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Excluded Products */}
                                    {singleCouponDetails?.excludedProducts?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed red",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="fw-semibold text-muted mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Excluded Products :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.excludedProducts?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.excludedProducts?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.excludedProducts.map((product, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#fce4ec",
                                                                color: "#c2185b",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {product?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Dependant Products */}
                                    {singleCouponDetails?.dependantProducts?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed #00a6ff",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Dependant Products :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.dependantProducts?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.dependantProducts?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.dependantProducts.map((product, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#ede7f6",
                                                                color: "#512da8",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {product?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Dependant Categories */}
                                    {singleCouponDetails?.dependantCategories?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed #0099ff",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Dependant Categories :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.dependantCategories?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.dependantCategories?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.dependantCategories.map((category, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#e8f5e9",
                                                                color: "#388e3c",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {category?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Included Outlets */}
                                    {singleCouponDetails?.includedOutlets?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed green",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Included Outlets :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.includedOutlets?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.includedOutlets?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.includedOutlets.map((outlet, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#e8f5e9",
                                                                color: "#388e3c",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {outlet?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Primary Combo Categories */}
                                    {singleCouponDetails?.primaryComboCategories?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed green",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Primary Combo Categories :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.primaryComboCategories?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.primaryComboCategories?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.primaryComboCategories.map((category, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#e8f5e9",
                                                                color: "steelblue",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {category?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Secondary Combo Categories */}
                                    {singleCouponDetails?.secondaryComboCategories?.length > 0 && (
                                        <Col
                                            md={12}
                                            className="d-flex flex-wrap align-items-center gap-2 mb-2"
                                            style={{
                                                fontSize: "1em",
                                                color: "#444",
                                                background: "#f9f9f9",
                                                padding: "8px",
                                                borderRadius: "8px",
                                                border: "1px dashed green",
                                            }}
                                        >
                                            <div className="d-flex align-items-center w-100">
                                                <h6 className="text-muted fw-semibold mt-2" style={{ marginRight: "8px", fontSize: "13px", flexShrink: 0 }}>
                                                    Secondary Combo Categories :
                                                </h6>
                                                <div
                                                    className="d-flex flex-wrap gap-1"
                                                    style={{
                                                        maxHeight: singleCouponDetails?.secondaryComboCategories?.length > 8 ? "120px" : "auto",
                                                        overflowY: singleCouponDetails?.secondaryComboCategories?.length > 8 ? "auto" : "visible",
                                                        flex: 1
                                                    }}
                                                >
                                                    {singleCouponDetails.secondaryComboCategories.map((category, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                background: "#e8f5e9",
                                                                color: "burlywood",
                                                                borderRadius: "16px",
                                                                padding: "5px 10px",
                                                                fontWeight: "500",
                                                                fontSize: "11px",
                                                                alignSelf: "center",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            {category?.name}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    )}

                                    {/* Terms and Conditions */}
                                    {singleCouponDetails?.termsAndConditions?.length > 0 && (
                                        <div
                                            style={{
                                                background: "#fff",
                                                padding: "20px",
                                                borderRadius: "10px",
                                                border: "2px dashed #4CAF50",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <h6 className="text-primary fw-semibold">Terms and Conditions:</h6>
                                            <ul className="text-secondary">
                                                {singleCouponDetails.termsAndConditions.map((term, index) => (
                                                    <li key={index}>{term}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Description */}
                                    {singleCouponDetails?.description && (
                                        <div
                                            style={{
                                                background: "#fff",
                                                padding: "20px",
                                                borderRadius: "10px",
                                                border: "2px dashed #4CAF50",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <h6 className="text-muted fw-semibold">Description:</h6>
                                            <p className="text-secondary">{singleCouponDetails.description}</p>
                                        </div>
                                    )}

                                    {/* Footer */}
                                    <div className="text-center mt-4">
                                        <small className="text-muted">
                                            Hurry up! Offer valid for a limited time only.
                                        </small>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        ) : null}

                        {/* DELETE COUPON MODAL */}
                        {openDeleteModal ? (
                            <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to delete this Coupon? This action cannot be undone.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" onClick={handleDeleteCoupon}>
                                        {isDeleteBtnLoading ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> :
                                            "Delete Coupon"
                                        }
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}

                        {/* EDIT COUPON DETAILS MODAL */}
                        {openEditModal ? (
                            <Modal
                                show={openEditModal}
                                onHide={handleCloseEditModal}
                                centered
                                size="xl"
                                aria-labelledby="contained-modal-title-vcenter"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">EDIT COUPON DETAILS</Modal.Title>
                                </Modal.Header>

                                <Form onSubmit={handleSubmitEditForm}>
                                    <Modal.Body>
                                        <Row className="mb-3">
                                            {[
                                                { id: 'isBogoCoupon', label: 'BOGO COUPON', description: 'BOGO coupon allows you to buy one and get another one free.' },
                                                { id: 'isUniversalCoupon', label: 'UNIVERSAL COUPON', description: 'Universal coupon can be applied to any item in the store.' },
                                                { id: 'isCartCoupon', label: 'CART COUPON', description: 'Cart coupon gives a discount on the entire cart.' },
                                                { id: 'isSizeUpgradeCoupon', label: 'SIZE UPGRADE COUPON', description: 'Size upgrade coupon lets you upgrade the product size for free or a discount.' },
                                                { id: 'isProductCoupon', label: 'PRODUCT COUPON', description: 'Product coupon provides a discount on a specific product.' },
                                                { id: 'isCategoryCoupon', label: 'CATEGORY COUPON', description: 'Category coupon gives a discount on all items in a particular category.' },
                                                { id: 'isSpecialCategoryCoupon', label: 'SPECIAL CATEGORY COUPON', description: 'Special category coupon applies to selected special categories only.' },
                                                { id: 'isSpecialProductCoupon', label: 'SPECIAL PRODUCT COUPON', description: 'Special product coupon offers discounts on special, featured products.' },
                                                { id: 'isComboCoupon', label: 'COMBO COUPON', description: 'Combo Coupon type allow you to create a coupon in which two products from two category group can be sold at specific price or specific discount can be applied.' },
                                                { id: 'isFreebieCoupon', label: 'FREEBIE COUPON', description: 'Freebie coupon offer product for no cost or for 0 Rs' },
                                            ].map((button) => (
                                                <Col md={3} className="mb-3" key={button.id}>
                                                    <Button
                                                        variant={selectedCheckbox === button.id ? 'primary' : 'outline-secondary'}
                                                        disabled={selectedCheckbox && selectedCheckbox !== button.id}
                                                        className={`toggle-button ${selectedCheckbox === button.id ? 'selected' : ''}`}
                                                        style={{ width: '100%' }}
                                                    >
                                                        {button.label}
                                                    </Button>
                                                </Col>
                                            ))}

                                            {/* Description */}
                                            <Col xs={12} md={12} lg={12} className='d-flex justify-content-center'>
                                                {selectedCheckbox ? (
                                                    <span className='fw-semibold text-white' style={{ fontSize: '15px', backgroundColor: '#3AB857', padding: '5px 15px', borderRadius: '18px' }}>
                                                        {
                                                            [
                                                                { id: 'isBogoCoupon', description: 'Description - BOGO coupon allows you to buy one and get another one free.' },
                                                                { id: 'isUniversalCoupon', description: 'Description - Universal coupon can be applied to any item in the store.' },
                                                                { id: 'isCartCoupon', description: 'Description - Cart coupon gives a discount on the entire cart.' },
                                                                { id: 'isSizeUpgradeCoupon', description: 'Description - Size upgrade coupon lets you upgrade the product size for free or a discount.' },
                                                                { id: 'isProductCoupon', description: 'Description - Product coupon provides a discount on a specific product.' },
                                                                { id: 'isCategoryCoupon', description: 'Description - Category coupon gives a discount on all items in a particular category.' },
                                                                { id: 'isSpecialCategoryCoupon', description: 'Description - Special category coupon applies to selected special categories only.' },
                                                                { id: 'isSpecialProductCoupon', description: 'Description - Special product coupon offers discounts on special, featured products.' },
                                                                { id: 'isComboCoupon', description: 'Combo Coupon type allow you to create a coupon in which two products from two category group can be sold at specific price or specific discount can be applied.' },
                                                                { id: 'isFreebieCoupon', description: 'Description - Freebie coupon offer product for no cost or for 0 Rs' },
                                                            ].find((item) => item.id === selectedCheckbox)?.description
                                                        }
                                                    </span>
                                                ) : <span className='fw-semibold text-muted' style={{ fontSize: '15px', backgroundColor: '#E0FFD9', padding: '5px 15px', borderRadius: '18px' }}>Please Select a Coupon Type From Above</span>}
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Title <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Title"
                                                        name="title"
                                                        value={editData.title || ""}
                                                        onChange={handleEditFormInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Coupon Code <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Coupon Code"
                                                        name="couponCode"
                                                        value={editData.couponCode || ""}
                                                        onChange={(e) =>
                                                            handleEditFormInputChange({
                                                                target: {
                                                                    name: e.target.name,
                                                                    value: e.target.value.toUpperCase(),
                                                                },
                                                            })
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col className='mb-3' md={2}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Validity Start Date
                                                    </Form.Label>
                                                    <DatePicker
                                                        selected={editData?.validityStartDate ? new Date(editData?.validityStartDate) : null}
                                                        onChange={handleEditStartDate}
                                                        placeholderText="Start Date"
                                                        className="form-control"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Validity End Date
                                                    </Form.Label>
                                                    <DatePicker
                                                        onChange={handleEditEndDate}
                                                        placeholderText="Validity Start Date"
                                                        className="form-control"
                                                        selected={editData?.validityEndDate ? new Date(editData?.validityEndDate) : null}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label className='fw-semibold'>
                                                        Order Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="orderType"
                                                        value={editData.orderType || ""}
                                                        onChange={handleEditFormInputChange}
                                                    >
                                                        <option value="" disabled>Select</option>
                                                        <option value="ALL">ALL</option>
                                                        <option value="DELIVERY">DELIVERY</option>
                                                        <option value="PICKUP">PICK-UP</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Select Day of a week
                                                    </Form.Label>
                                                    <Form.Select
                                                        onChange={handleEditFormInputChange}
                                                        name="dayOfWeek"
                                                        value={editData?.dayOfWeek}
                                                    >
                                                        <option value="">Select Day</option>
                                                        <option value="0">SUNDAY</option>
                                                        <option value="1">MONDAY</option>
                                                        <option value="2">TUESDAY</option>
                                                        <option value="3">WEDNESDAY</option>
                                                        <option value="4">THURSDAY</option>
                                                        <option value="5">FRIDAY</option>
                                                        <option value="6">SATURDAY</option>
                                                        <option value="null">ANY DAY OF THE WEEK</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Usage Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="usageType"
                                                        value={editData.usageType}
                                                        onChange={handleEditFormInputChange}
                                                    >
                                                        <option value="">Select Usage</option>
                                                        <option value="ONE-TIME">ONE-TIME</option>
                                                        <option value="MULTIPLE">MULTIPLE</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>

                                            <Col md={2} lg={2}>
                                                <Form.Label className="fw-semibold">
                                                    Daily Usage Limit
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    placeholder="Daily Usage Limit"
                                                    type="number"
                                                    className="no-arrows"
                                                    name="dailyUsageLimit"
                                                    value={editData.dailyUsageLimit}
                                                    onChange={handleEditFormInputChange}
                                                />
                                            </Col>

                                            <Col md="2" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Start Time
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        placeholder="Opening Time"
                                                        name="startTime"
                                                        value={editData?.startTime}
                                                        onChange={handleEditFormInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="2" lg="2">
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        End Time
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="time"
                                                        placeholder="Closing Time"
                                                        name="endTime"
                                                        value={editData?.endTime}
                                                        onChange={handleEditFormInputChange}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Included Outlets
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selections?.selectedIncludedOutlets || []}
                                                    onChange={(value) => handleChange("selectedIncludedOutlets", value)}
                                                    options={outletData.filter(
                                                        (outlet) =>
                                                            !selections?.selectedExcludedOutlets?.some(
                                                                (excludedOutlet) => excludedOutlet.value === outlet.value
                                                            )
                                                    )}
                                                    styles={customStyles}
                                                    placeholder="Select Included Outlets"
                                                    isDisabled={!!selections?.selectedExcludedOutlets?.length}
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>

                                            <Col md="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Outlets
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selections.selectedExcludedOutlets || []}
                                                    onChange={(value) => handleChange("selectedExcludedOutlets", value)}
                                                    options={outletData.filter(
                                                        (outlet) =>
                                                            !selections.selectedIncludedOutlets?.some(
                                                                (includedOutlet) => includedOutlet.value === outlet.value
                                                            )
                                                    )}
                                                    styles={customStyles}
                                                    placeholder="Select Excluded Outlets"
                                                    isDisabled={!!selections?.selectedIncludedOutlets?.length}
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>

                                            {/* Freebie Product Selection (Only for Freebie Coupon) */}
                                            {selectedCheckbox === 'isFreebieCoupon' && (
                                                <>
                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label className="fw-semibold">
                                                                Freebie Product <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Select
                                                                options={productsList
                                                                    .filter(product => product.isFreebieProduct === true)
                                                                    .map((product) => ({
                                                                        value: product._id,
                                                                        label: product.name
                                                                    }))}
                                                                value={editData.freebieProduct ? {
                                                                    value: editData.freebieProduct,
                                                                    label: productsList.find(p => p._id === editData.freebieProduct)?.name || 'Select Product'
                                                                } : null}
                                                                onChange={(selectedOption) => {
                                                                    setEditData(prev => ({
                                                                        ...prev,
                                                                        freebieProduct: selectedOption?.value || ''
                                                                    }));
                                                                }}
                                                                placeholder="Select Freebie Product"
                                                                classNamePrefix="select"
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={2}>
                                                        <Form.Group>
                                                            <Form.Label className="fw-semibold">
                                                                Freebie Quantity <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                min="1"
                                                                name="freebieQuantity"
                                                                value={editData.freebieQuantity || ''}
                                                                onChange={handleEditFormInputChange}
                                                                placeholder="Quantity"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            )}

                                            {/* Select Applicable Categories */}
                                            {
                                                (selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === 'isBogoCoupon' || selectedCheckbox === 'isSizeUpgradeCoupon' || selectedCheckbox === 'isCartCoupon') &&
                                                (<Col md={6} className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Select Applicable Categories
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        isDisabled={selectedCheckbox === "isSpecialProductCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                        components={animatedComponents}
                                                        options={categoriesList}
                                                        value={selections.selectedApplicableCategories || []}
                                                        onChange={(value) => handleChange("selectedApplicableCategories", value)}
                                                        placeholder="Select Applicable Categories"
                                                        closeMenuOnSelect={false}
                                                        styles={customStyles}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#e9ecef",
                                                                primary: "#007bff",
                                                            },
                                                        })}
                                                    />
                                                </Col>)
                                            }

                                            {
                                                selectedCheckbox === 'isSizeUpgradeCoupon' && selections?.selectedApplicableProducts?.length === 0 &&
                                                <Col md="6" className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Select Applicable Product <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Select
                                                        options={editData?.newSizeUpgradeAddon ? (
                                                            newProductsFromAddons?.map((item) => ({
                                                                value: item?._id,
                                                                label: item?.name
                                                            }))
                                                        ) : (
                                                            addonList?.map((rm) => ({
                                                                value: rm?.product?._id,
                                                                label: rm?.product?.name
                                                            }))
                                                        )}
                                                        value={
                                                            selectedProducts && selectedProducts.length > 0
                                                                ? (
                                                                    editData?.newSizeUpgradeAddon
                                                                        ? newProductsFromAddons?.map((item) => ({
                                                                            value: item?._id,
                                                                            label: item?.name,
                                                                        }))
                                                                        : addonList?.map((rm) => ({
                                                                            value: rm?.product?._id,
                                                                            label: rm?.product?.name,
                                                                        }))
                                                                ).find((option) => option?.value === selectedProducts[0]?.value)
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                handleEditInputChange({
                                                                    target: { name: "applicableProducts", value: selectedOption.value }
                                                                });
                                                            } else {
                                                                handleEditInputChange({
                                                                    target: { name: "applicableProducts", value: "" }
                                                                });
                                                            }
                                                        }}
                                                        classNamePrefix="react-select"
                                                        isClearable
                                                        placeholder="Select Product"
                                                    />
                                                </Col>
                                            }

                                            {
                                                (selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon" || selectedCheckbox === 'isSizeUpgradeCoupon' || selectedCheckbox === 'isCartCoupon') &&
                                                (<Col md={6}>
                                                    <Form.Label className="fw-semibold">
                                                        Select Applicable Products
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isUniversalCoupon" || selections?.selectedApplicableCategories?.length > 0 || selectedCheckbox === "isFreebieCoupon"}
                                                        components={animatedComponents}
                                                        options={
                                                            editData?.newSizeUpgradeAddon ?
                                                                addonProductsInfo?.filter(
                                                                    (product) =>
                                                                        !selections?.selectedExcludedProducts?.some(
                                                                            (excludedProduct) => excludedProduct.value === product.value
                                                                        )
                                                                ) :
                                                                productsInfo?.filter(
                                                                    (product) =>
                                                                        !selections?.selectedExcludedProducts?.some(
                                                                            (excludedProduct) => excludedProduct.value === product.value
                                                                        )
                                                                )
                                                        }
                                                        value={selections.selectedApplicableProducts || []}
                                                        onChange={(value) => handleChange("selectedApplicableProducts", value)}
                                                        placeholder="Select Applicable Products"
                                                        styles={customStyles}
                                                        closeMenuOnSelect={false}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#e9ecef",
                                                                primary: "#007bff",
                                                            },
                                                        })}
                                                    />
                                                </Col>)
                                            }

                                            {
                                                (selectedCheckbox === "isSpecialCategoryCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === "isProductCoupon") &&
                                                <>
                                                    <Col md="6" className='mb-3'>
                                                        <Form.Label className="fw-semibold">
                                                            Select Dependent Categories
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            components={animatedComponents}
                                                            value={selections?.selectedDependentCategories || []}
                                                            onChange={(value) => handleChange("selectedDependentCategories", value)}
                                                            isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                            options={categoriesList}
                                                            styles={customStyles}
                                                            placeholder="Select Dependent Categories"
                                                            closeMenuOnSelect={false}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 0,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#e9ecef",
                                                                    primary: "#007bff",
                                                                },
                                                            })}
                                                        />
                                                    </Col>

                                                    <Col md="6" className='mb-3'>
                                                        <Form.Label className="fw-semibold">
                                                            Select Dependent Products
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            components={animatedComponents}
                                                            value={selections.selectedDependentProducts || []}
                                                            onChange={(value) => handleChange("selectedDependentProducts", value)}
                                                            isDisabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                            options={productsInfo}
                                                            styles={customStyles}
                                                            placeholder="Select Dependent Products"
                                                            closeMenuOnSelect={false}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 0,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#e9ecef",
                                                                    primary: "#007bff",
                                                                },
                                                            })}
                                                        />
                                                    </Col>
                                                </>
                                            }

                                            {
                                                (selections?.selectedExcludedProducts?.length > 0 || selectedCheckbox === 'isCategoryCoupon' || selectedCheckbox === 'isSpecialCategoryCoupon' || selectedCheckbox === 'isSizeUpgradeCoupon' || selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isBogoCoupon' || selectedCheckbox === 'isUniversalCoupon' || selectedCheckbox === 'isComboCoupon' || selectedCheckbox === 'isFreebieCoupon') && (
                                                    <Col md="6" lg="6" className='mb-3'>
                                                        <Form.Label className="fw-semibold">
                                                            Select Excluded Products
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            components={animatedComponents}
                                                            value={selections?.selectedExcludedProducts || []}
                                                            onChange={(value) => handleChange("selectedExcludedProducts", value)}
                                                            options={
                                                                editData.newSizeUpgradeAddon ?
                                                                    exAddonProductInfo?.filter(
                                                                        (product) =>
                                                                            !selections.selectedApplicableProducts?.some(
                                                                                (excludedProduct) => excludedProduct.value === product.value
                                                                            )
                                                                    ) :
                                                                    exProductInfo?.filter(
                                                                        (product) =>
                                                                            !selections.selectedApplicableProducts?.some(
                                                                                (excludedProduct) => excludedProduct.value === product.value
                                                                            )
                                                                    )
                                                            }
                                                            styles={customStyles}
                                                            placeholder="Select Excluded Products"
                                                            closeMenuOnSelect={false}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 0,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#e9ecef",
                                                                    primary: "#007bff",
                                                                },
                                                            })}
                                                        />
                                                    </Col>
                                                )
                                            }

                                            {(selectedCheckbox !== 'isFreebieCoupon') && (
                                                <Col md={6} className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Select Excluding Addons
                                                    </Form.Label>
                                                    <Select
                                                        components={animatedComponents}
                                                        isMulti
                                                        options={allAddonList.map(addon => ({
                                                            value: addon._id,
                                                            label: addon.title
                                                        }))}
                                                        value={selectedAddonGroups}
                                                        onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select addon groups..."
                                                    />
                                                </Col>
                                            )}

                                            {(selectedCheckbox !== 'isFreebieCoupon') && (
                                                <Col md={6} className='mb-3'>
                                                    <Form.Group>
                                                        <Form.Label className='fw-semibold'>Select Excluding Addon Values</Form.Label>
                                                        <Select
                                                            components={animatedComponents}
                                                            isMulti
                                                            options={filteredAddonValues}
                                                            value={
                                                                editData?.excludedAddons?.map((val) => ({
                                                                    value: val,
                                                                    label: `${val.addonTitle} - ${val.addonValueTitle}`,
                                                                })) || []
                                                            }
                                                            onChange={(selectedOptions) => {
                                                                console.log("Selected Value Option :", selectedOptions);

                                                                setEditData((prev) => ({
                                                                    ...prev,
                                                                    excludedAddons: selectedOptions
                                                                        ? selectedOptions.map((opt) => ({
                                                                            addonId: opt.value.addonId,
                                                                            addonValueId: opt.value.addonValueId ? opt.value.addonValueId : opt.value.addValueId,
                                                                            addonTitle: opt.value.addonTitle,
                                                                            addonValueTitle: opt.value.addonValueTitle,
                                                                        }))
                                                                        : [],
                                                                }));
                                                            }}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            placeholder="Select addon values to exclude..."
                                                            getOptionLabel={(option) => option.label}
                                                            getOptionValue={(option) =>
                                                                `${option.value.addonId}-${option.value.addonValueId}`
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            <Col md="6" lg="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Applicable Levels
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selections?.selectedApplicableLevels || []}
                                                    onChange={(value) => handleChange("selectedApplicableLevels", value)}
                                                    options={levelsData}
                                                    styles={customStyles}
                                                    placeholder="Select Applicable Levels"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Col>

                                            {
                                                selectedCheckbox === 'isComboCoupon' && (
                                                    <>
                                                        <Col md="6" className='mb-3'>
                                                            <Form.Label className="fw-semibold">
                                                                Primary Combo Categories
                                                            </Form.Label>
                                                            <Select
                                                                isMulti
                                                                components={animatedComponents}
                                                                value={selections?.primaryComboCategories || []}
                                                                onChange={(value) => handleChange("primaryComboCategories", value)}
                                                                options={categoriesList.filter(
                                                                    (category) =>
                                                                        !selections.secondaryComboCategories?.some(
                                                                            (cat) => cat.value === category.value
                                                                        )
                                                                )}
                                                                styles={customStyles}
                                                                placeholder="Primary Combo Categories"
                                                                closeMenuOnSelect={false}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    borderRadius: 0,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: "#e9ecef",
                                                                        primary: "#007bff",
                                                                    },
                                                                })}
                                                            />
                                                        </Col>

                                                        <Col md="6" className='mb-3'>
                                                            <Form.Label className="fw-semibold">
                                                                Secondary Combo Categories
                                                            </Form.Label>
                                                            <Select
                                                                isMulti
                                                                components={animatedComponents}
                                                                value={selections.secondaryComboCategories || []}
                                                                onChange={(value) => handleChange("secondaryComboCategories", value)}
                                                                options={categoriesList.filter(
                                                                    (category) =>
                                                                        !selections.primaryComboCategories?.some(
                                                                            (cat) => cat.value === category.value
                                                                        )
                                                                )}
                                                                styles={customStyles}
                                                                placeholder="Secondary Combo Categories"
                                                                closeMenuOnSelect={false}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    borderRadius: 0,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: "#e9ecef",
                                                                        primary: "#007bff",
                                                                    },
                                                                })}
                                                            />
                                                        </Col>
                                                    </>
                                                )
                                            }

                                            {
                                                selectedCheckbox === "isSizeUpgradeCoupon" && (<Col md="3">
                                                    <Form.Label className="fw-semibold">
                                                        Select Size Upgrade Addon <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="newSizeUpgradeAddon"
                                                        disabled={[
                                                            "isUniversalCoupon",
                                                            "isBogoCoupon",
                                                            "isCartCoupon",
                                                            "isProductCoupon",
                                                            "isCategoryCoupon",
                                                            "isSpecialCategoryCoupon",
                                                            "isSpecialProductCoupon",
                                                            "isFreebieCoupon"
                                                        ].includes(selectedCheckbox) || !editData?.sizeUpgradeAddon}
                                                        value={editData?.newSizeUpgradeAddon?._id}
                                                        onChange={handleEditFormInputChange}
                                                    >
                                                        <option value="">Select Size Upgrade Addon</option>
                                                        {newSizeAddonsList?.map((add) => (
                                                            <option value={add?._id} key={add?._id}>{add?.title}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>)
                                            }

                                            <Col className='mb-2' md="3">
                                                <Form.Label className="fw-semibold">
                                                    Coupon Status <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="status"
                                                    value={editData.status}
                                                    onChange={handleEditFormInputChange}
                                                >
                                                    <option value="">Select Option</option>
                                                    <option value="ACTIVE">ACTIVE</option>
                                                    <option value="INACTIVE">INACTIVE</option>
                                                </Form.Select>
                                            </Col>

                                            <Col className='mb-2' md="3">
                                                <Form.Label className="fw-semibold">
                                                    Hide Coupon <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isHidden"
                                                    value={editData.isHidden}
                                                    onChange={handleEditFormInputChange}
                                                >
                                                    <option value="">Select Option</option>
                                                    <option value="true">YES</option>
                                                    <option value="false">NO</option>
                                                </Form.Select>
                                            </Col>

                                            {(selectedCheckbox !== 'isFreebieCoupon') && (
                                                <Col md="3">
                                                    <Form.Label className="fw-semibold">
                                                        Is Mrp Coupon? <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="isMrpDiscount"
                                                        value={editData.isMrpDiscount}
                                                        onChange={handleEditFormInputChange}
                                                        disabled={selectedCheckbox === "isFreebieCoupon"}
                                                    >
                                                        <option value="">Select Option</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Col>
                                            )}

                                            {(selectedCheckbox !== 'isFreebieCoupon') && (
                                                <Col md="3">
                                                    <Form.Label className="fw-semibold">
                                                        Cashback Coupon <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="isCashbackCoupon"
                                                        value={editData.isCashbackCoupon}
                                                        onChange={handleEditFormInputChange}
                                                        disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isComboCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                    >
                                                        <option value="">Select Option</option>
                                                        <option value="true">YES</option>
                                                        <option value="false">NO</option>
                                                    </Form.Select>
                                                </Col>
                                            )}

                                            {(selectedCheckbox !== 'isFreebieCoupon') && (
                                                <Col md={3} className='mb-3'>
                                                    <Form.Label className="fw-semibold">
                                                        Max Addons Allowed <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        placeholder="Max Addons Allowed"
                                                        className="no-arrows"
                                                        type="number"
                                                        name="maxAddonsAllowed"
                                                        value={
                                                            editData.maxAddonsAllowed === null || editData.maxAddonsAllowed === undefined
                                                                ? undefined
                                                                : editData.maxAddonsAllowed
                                                        }
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                                handleEditFormInputChange(e);
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                            )}

                                            {
                                                (selectedCheckbox === 'isUniversalCoupon' || selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isProductCoupon' || selectedCheckbox === 'isCategoryCoupon' || selectedCheckbox === 'isComboCoupon') && (
                                                    <>
                                                        <Col md={3} className="mb-3">
                                                            <Form.Label className="fw-semibold">
                                                                Discount Percent <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                min={0}
                                                                max={100}
                                                                placeholder="Discount Percent"
                                                                className="no-arrows"
                                                                type="number"
                                                                name="discountPercent"
                                                                value={editData.discountPercent || ""}
                                                                onChange={handleEditFormInputChange}
                                                                disabled={selectedCheckbox === "isFreebieCoupon"}
                                                            />
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Label className="fw-semibold">
                                                                Max. Dis. Amount
                                                            </Form.Label>
                                                            <Form.Control
                                                                min={0}
                                                                placeholder="Max. Dis. Amount"
                                                                type="number"
                                                                className="no-arrows"
                                                                name="maxDiscountAmount"
                                                                value={editData.maxDiscountAmount || ""}
                                                                onChange={handleEditFormInputChange}
                                                                disabled={selectedCheckbox === "isFreebieCoupon"}
                                                            />
                                                        </Col>
                                                    </>
                                                )
                                            }

                                            {
                                                (selectedCheckbox === 'isCartCoupon' || selectedCheckbox === 'isProductCoupon' || selectedCheckbox === 'isCategoryCoupon' || selectedCheckbox === 'isComboCoupon') && (
                                                    <Col md={3}>
                                                        <Form.Label className="fw-semibold">
                                                            Discount Amount <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            min={0}
                                                            step={0.01}
                                                            placeholder="Discount Amount"
                                                            className="no-arrows"
                                                            type="number"
                                                            name="discountAmount"
                                                            value={editData.discountAmount || ""}
                                                            onChange={handleEditFormInputChange}
                                                            disabled={selectedCheckbox === "isFreebieCoupon"}
                                                        />
                                                    </Col>
                                                )
                                            }

                                            <Col className='mb-3' md={3} lg={3}>
                                                <Form.Label className="fw-semibold">
                                                    Min. Order Amount
                                                </Form.Label>
                                                <Form.Control
                                                    min={0}
                                                    placeholder="Min. Order Amount"
                                                    type="number"
                                                    className="no-arrows"
                                                    name="minOrderAmount"
                                                    value={editData.minOrderAmount}
                                                    onChange={handleEditFormInputChange}
                                                />
                                            </Col>

                                            {
                                                (
                                                    selectedCheckbox === 'isSpecialCategoryCoupon' || selectedCheckbox === 'isSpecialProductCoupon' || selectedCheckbox === 'isComboCoupon'
                                                ) && (
                                                    <>
                                                        <Col md={3}>
                                                            <Form.Label className="fw-semibold">
                                                                Discount Price <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                min={0}
                                                                step={0.01}
                                                                disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                                placeholder="Discount Price"
                                                                className="no-arrows"
                                                                type="number"
                                                                name="discountPrice"
                                                                value={editData.discountPrice !== undefined && editData.discountPrice !== null ? editData.discountPrice : ""}
                                                                onChange={handleEditFormInputChange}
                                                            />
                                                        </Col>

                                                        <Col md={3} className='mb-3'>
                                                            <Form.Group>
                                                                <Form.Label className="fw-semibold">
                                                                    Applicable Quantity Type <span className="text-danger">*</span>
                                                                </Form.Label>
                                                                <Form.Select
                                                                    name="applicableQuantityType"
                                                                    value={editData.applicableQuantityType || ""}
                                                                    onChange={handleEditFormInputChange}
                                                                    disabled={selectedCheckbox === "isBogoCoupon" || selectedCheckbox === "isUniversalCoupon" || selectedCheckbox === "isCartCoupon" || selectedCheckbox === "isProductCoupon" || selectedCheckbox === "isCategoryCoupon" || selectedCheckbox === "isSizeUpgradeCoupon" || selectedCheckbox === "isFreebieCoupon"}
                                                                >
                                                                    <option value="">Select Applicable Quantity Type</option>
                                                                    <option value="SINGLE">SINGLE</option>
                                                                    {
                                                                        selectedCheckbox !== 'isComboCoupon' ? (<option value="MULTIPLE">MULTIPLE</option>) : null
                                                                    }
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                )
                                            }

                                            <Col md={12} className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Description <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    placeholder="Description"
                                                    name="description"
                                                    value={editData.description || ""}
                                                    onChange={handleEditFormInputChange}
                                                />
                                            </Col>

                                            <Col md="12" className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Terms and Conditions <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <div className="d-flex mb-2">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Add a term"
                                                            value={currentTerm}
                                                            onChange={(e) => setCurrentTerm(e.target.value)}
                                                            className="me-2"
                                                        />
                                                        <Button
                                                            variant="success"
                                                            disabled={!currentTerm.trim()}
                                                            onClick={addTerm}
                                                        >ADD</Button>
                                                    </div>
                                                    {editData?.termsAndConditions?.length > 0 && (
                                                        <ul className="list-group">
                                                            {editData?.termsAndConditions?.map((term, index) => (
                                                                <li
                                                                    key={index}
                                                                    className="list-group-item d-flex justify-content-between align-items-center"
                                                                >
                                                                    {term}
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-danger rounded-pill"
                                                                        onClick={() => removeTerm(index)}
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="primary"
                                            style={{ width: '20%' }}
                                            type="submit"
                                            disabled={isEditBtnLoading}
                                        >
                                            {isEditBtnLoading ? 'Saving...' : 'SAVE CHANGES'}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                    </Row>
                </div>
            </div>

            {/* Add the CSS animation */}
            <style>
                {`
                    @keyframes skeletonPulse {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}
            </style>
        </React.Fragment>
    )
}

export default CouponsList